(function() {
    var topicTmpl = 
    '{{#each (item, index) in topicList}}' +
    '<li>' +
        '<span class="rdo-wrap btn-type4">' +
            '{{# if (index == 0) { #}}' +
            '<input type="radio" name="sympCd" id="topic{{index}}" value="{{item.value}}" data-topic-name="{{item.name}}" data-error-msg="정확한 제품증상을 선택해 주세요." data-required="true" required>' +
            '{{# } else { #}}' +
            '<input type="radio" name="sympCd" id="topic{{index}}" value="{{item.value}}" data-topic-name="{{item.name}}">' +
            '{{# } #}}' +
            '<label for="topic{{index}}"><span>{{item.name}}</span></label>' +
        '</span>' +
    '</li>' + 
    '{{/each}}';

    var sub1TopicTmpl = 
    '<option value="" name="sympSubCode" class="placeholder">증상을 선택해 주세요</option>' +
    '{{#each (item, index) in subTopicList}}' +
        '<option value="{{item.value}}" name="sympSubCode">{{item.name}}</option>' +
    '{{/each}}';

    var sub2TopicTmpl = 
    '<option value="" name="sympCodeThree" class="placeholder">세부 증상을 선택해 주세요</option>' +
    '{{#each (item, index) in threeTopicList}}' +
        '{{# if (typeof item.noisePopupFlag != "undefined") { #}}'+
            '<option value="{{item.value}}" name="sympCodeThree" data-noise="{{item.noisePopupFlag}}">{{item.name}}</option>' +
        '{{# } else { #}}' +
            '<option value="{{item.value}}" name="sympCodeThree">{{item.name}}</option>' +
        '{{# } #}}'+
    '{{/each}}';
    
    var engineerTmpl =
    '{{#each (item, index) in engineerList}}' +

    /* BTOCSITE-BTOCSITE-7660 고객지원 - 출장/내방/예약변경 시 SE 사진 비노출 요청 */
    // BTOCSITE-BTOCSITE-7660 슬라이드 원본
    // '<div class="slide-conts ui_carousel_slide">' +
    //     '<div class="engineer-box">' +
    //         '{{# if (index == 0) { #}}' +
    //             '<input type="radio" name="engineer" id="engineer{{index}}" data-engineer-name="{{item.engineerName}}" data-engineer-code="{{item.engineerCode}}" data-center-name="{{item.centerName}}" data-center-code="{{item.centerCode}}" data-image="{{item.image}}" data-resrv-seq="{{item.resrvSeq}}" value="{{index}}" checked>' +
    //         '{{# } else { #}}' +
    //             '<input type="radio" name="engineer" id="engineer{{index}}" data-engineer-name="{{item.engineerName}}" data-engineer-code="{{item.engineerCode}}" data-center-name="{{item.centerName}}" data-center-code="{{item.centerCode}}" data-image="{{item.image}}" data-resrv-seq="{{item.resrvSeq}}" value="{{index}}">' +
    //         '{{# } #}}' +
    //         '<label for="engineer{{index}}">' +
    //             // '<div class="img">' +
    //             //     '<img src="{{item.image}}" alt="" aria-hidden="true">' +
    //             // '</div>' +
    //             // '<p class="tit">{{item.engineerName}}</p>' +
    //             // '<p class="desc">{{item.centerName}}</p>' +
    //             '<span>{{item.engineerName}}</span>' +
    //             '<span>{{item.centerName}}</span>' +
    //         '</label>' +
    //     '</div>' +  
    // '</div>' +

        '<li class="chk-wrap">' +
            '{{# if (index == 0) { #}}' +
                '<input type="radio" name="engineer" id="engineer{{index}}" data-engineer-name="{{item.engineerName}}" data-engineer-code="{{item.engineerCode}}" data-enter-channel="{{item.enterChannel}}" data-center-name="{{item.centerName}}" data-center-code="{{item.centerCode}}" data-image="{{item.image}}" data-resrv-seq="{{item.resrvSeq}}" value="{{index}}" checked>' +
            '{{# } else { #}}' +
                '<input type="radio" name="engineer" id="engineer{{index}}" data-engineer-name="{{item.engineerName}}" data-engineer-code="{{item.engineerCode}}" data-enter-channel="{{item.enterChannel}}" data-center-name="{{item.centerName}}" data-center-code="{{item.centerCode}}" data-image="{{item.image}}" data-resrv-seq="{{item.resrvSeq}}" value="{{index}}">' +
            '{{# } #}}' +
            '<label for="engineer{{index}}">' +
                // '<div class="img">' +
                //     '<img src="{{item.image}}" alt="" aria-hidden="true">' +
                // '</div>' +
                // '<p class="tit">{{item.engineerName}}</p>' +
                // '<p class="desc">{{item.centerName}}</p>' +
                '<span>{{item.engineerName}}</span>' +
                '<span>{{item.centerName}}</span>' +
            '</label>' +
        '</li>' +
        /* BTOCSITE-BTOCSITE-7660 고객지원 - 출장/내방/예약변경 시 SE 사진 비노출 요청 */
    '{{/each}}';

    // BTOCSITE-35243 홈페이지 고객지원 회원기반 시범운영 (출장서비스)
    var loginEnterPopupTemplate = 
    '<article id="loginEnterPopup" class="popup-wrap small">' +
        '<header class="pop-header">'+
            '<h1 class="tit"><span>예약 안내</span></h1>'+
        '</header>'+
        '<section class="pop-conts common-pop non-members">'+
            '<div class="non-members-login">'+
                '<p class="hello-desc">'+
                'LGE.COM 회원이신가요?<br><br><b class="color-3">[로그인]</b>하시면 예약자 정보 입력 없이 <br>간편하게 이용하실 수 있습니다.'+
                '</p>'+
            '</div>'+
        '</section>'+
        '<footer class="pop-footer center">'+
        '<div class="btn-group">'+
            //'<button type="button" class="btn gray ui_modal_close"><span>비회원 예약</span></button>'+
            '<button type="button" class="btn gray" onclick="location.href=' + "'{{joinurl}}'" + '"><span>회원가입</span></button>'+
            '<button type="button" class="btn pink" onclick="location.href=' + "'{{loginurl}}'" + '"><span>로그인 하기</span></button>'+
        '</div>'+
        '</footer>'+
        '<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>'+
    '</article>';
    
    var validation;
    var authManager;
    var addressFinder;
    var dateUtil = vcui.date;
    var detectUtil = vcui.detect;
    var isLogin = lgkorUI.isLogin;
    var unifyId = "${loginInfo.unifyId}";
    
    var fastDateYn = "Y";

    var reservation = {
        init: function() {
            var self = this;

            self.$cont = $('.contents');
            self.$tabWrap = self.$cont.find('#tabs-prod');
            self.$prodWrap = self.$cont.find('.prod-wrap');
            self.$searchModelWrap = self.$cont.find('.prod-search-wrap');
            self.$myModelWrap = self.$cont.find('.my-product-wrap');
            self.$submitForm = self.$cont.find('#submitForm');

            self.$currentTab = self.$cont.find('.tabs').children();
            self.$stepContent = self.$cont.find('.step-content');
            self.$stepArea = self.$cont.find('#stepArea');
            self.$stepModel = self.$stepArea.find('#stepModel');
            self.$stepInput = self.$stepArea.find('#stepInput');
            self.$stepDate = self.$stepArea.find('#stepDate');
            self.$stepEngineer = self.$stepArea.find('#stepEngineer');
            self.$slideBox = self.$cont.find('.slide-box');

            // BTOCSITE-62364 모델번호, 제조번호 입력
            self.$modelSearchBox = self.$searchModelWrap.find('#modelSearchBox'); // 모델명/제조번호 입력
            self.$modelSelectBox = self.$searchModelWrap.find('#modelSelectBox'); // 제품군 선택 
            // 선택 제품 플로팅바
            self.$selectedModelBar = self.$cont.find('.goods-selected-wrap');

            self.$topicBox = self.$stepInput.find('#topicBox');
            self.$topicListWrap = self.$topicBox.find('#topicList');
            self.$topicList = self.$topicListWrap.find('.rdo-list');
            
            self.$saleInfoBox = self.$stepArea.find('#saleInfo');
            self.$productProblemsBox = self.$stepArea.find('#productProblems');
            self.$userInfoBox = self.$stepArea.find('#userInfo');
            // BTOCSITE-79185 고객지원 > 출장예약 > 전달사항 개인정보 관련
            self.$textarea = self.$productProblemsBox.find('#addDesc textarea');

            self.$fileUpload = self.$stepArea.find('#fileUpload');

            self.$salesDtWrap = self.$saleInfoBox.find('#salesDt');

            self.$subTopicWrap = self.$topicListWrap.find('.sub-topic');

            self.$sub1TopicBox = self.$stepInput.find('#stopic01');
            self.$sub1TopicSelect = self.$stepInput.find('#sTopic01Select');
            //self.$sub1TopicListWrap = self.$stepInput.find('#subTopicList');
            //self.$sub1TopicList = self.$subTopicListWrap.find('.rdo-list');

            self.$sub2TopicBox = self.$stepInput.find('#stopic02');
            self.$sub2TopicSelect = self.$stepInput.find('#sTopic02Select');
            //self.$sub2TopicListWrap = self.$stepInput.find('#subTopicList');
            //self.$sub2TopicList = self.$subTopicListWrap.find('.rdo-list');

            self.$solutionsBanner = self.$cont.find('#solutionBanner');
            self.$solutionsPopup = $('#solutionsPopup');

            self.$fanBox = self.$stepInput.find("#fanBox");
            self.$bdTypeBox = self.$stepInput.find("#bdTypeBox");
            self.$tvPositionBox = self.$stepInput.find('#tvPositionBox');
            self.$installTypeBox = self.$stepInput.find('#installTypeBox');
            self.$addFanBox = self.$stepInput.find('#addFanBox');

            self.$marketingUseAgree = self.$stepInput.find('#marketingUseAgree');
            
            //self.$dateBeforeWrap = self.$stepInput.find('#btn-datebefore-wrap');
            self.$dateBeforeWrap = self.$stepInput.find('.btn-datebefore');	//change
            self.$stepDateBefore = self.$stepInput.find('#stepDateBefore');
            //BTOCSITE-64827 고객지원 > 출장예약 > 모바일 > 날짜/시간 선택 UI 변경
            self.$dateWrap = self.$stepDate.find('.date-wrap');
            self.$timeWrap = self.$stepDate.find('.time-wrap-new');

            self.$scheduleBtnWrap = self.$stepInput.find('#schedule-btn-wrap');
            self.$modifyBtn = self.$scheduleBtnWrap.find('.btn-cal'); // 일정 수정 버튼
            self.$completeBtn = self.$scheduleBtnWrap.find('.btn-comp'); // 일정 확정 버튼

            self.$engineerOpener = $('[data-href="#choiceEngineerPopup"]');
            self.$engineerPopup = $('#choiceEngineerPopup');

            // BTOCSITE-22255 [약관] 비회원 출장서비스 신청 시 마케팅정보수신 약관 표출 요청
            self.$agreeWrap = self.$cont.find('.agree-wrap'); // 동의 영역
            self.$allAgree = self.$agreeWrap.find('.agree-all-chk'); //전체동의
            self.$marketingAgree = self.$stepArea.find('#marketingUseAgree'); //마케팅 동의

            /* BTOCSITE-BTOCSITE-7660 고객지원 - 출장/내방/예약변경 시 SE 사진 비노출 요청 */
            self.$engineerSlider = self.$engineerPopup.find('.engineer-popup');
            /* //BTOCSITE-BTOCSITE-7660 고객지원 - 출장/내방/예약변경 시 SE 사진 비노출 요청 */
            
            //BTOCSITE-69159 고객지원 > 출장예약 > 에어컨 > 설치장소 추가
            self.bdTypePopup = $('#bdTypePopup');

            self.$authPopup = $('#certificationPopup');
            // BTOCSITE-13599 요금 및 보증기간 안내 팝업 수정
            self.warrantyGuide = $('#ratesWarrantyGuidePopup');
            // BTOCSITE-29994 출장서비스 - 희망 일시 선택 후, 고객이 원하는 약속 일자 선택 가능 여부 데이터를 집계
            // BTOCSITE-31616 파일럿 종료) 출장서비스 - 희망 일시 선택 후, 고객이 원하는 약속 일자 선택 가능 여부 데이터를 집계
            // self.$desiredServey = self.$cont.find('.desired-servery-wrap');
            self.resultUrl = self.$searchModelWrap.data('resultUrl');
            self.isOneView = 'N';
            self.hirun = false;
            self.autoFlag = false;

            //BTOCSITE-80487 고객지원 > 출장예약 > 모델명 입력 > 자동완성 미선택
            if(lgkorUI.getParameterByName('mpFlag') == 'Y'){
                self.$tabWrap.vcTab('select', 1);
            }

            if ($('#appCall').length) {
                isLogin = true;
                self.isOneView = $('#appCall').val();
            }
            // BTOCSITE-27978 간편 출장서비스 접수 중 제품 재선택 시 입력창 disable해제
            if ($('#mainFlag').length) {
                self.isMainFlag = $('#mainFlag').val();
            }
            
            //cstFlag = 'Y' 이고 모델코드가 넘어올때 로직 추가 (서충원, 230621)
            if($('#servicePossbleFlag').val() == 'Y' && ($('#modelCode').val() != "" || $('#modelCode').val() != "undefined")){
                self.$tabWrap.hide();
            }

            self.$saleInfoBox.hide(); //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응

            //BTOCSITE-82900 고객지원 > 메인 리뉴얼 > 서비스 재접수
            $('input[name=selectAcptNo]').val(lgkorUI.getParameterByName('selectAcptNo'));

            var register = {
                privcyCheck: {
                    required: true,
                    msgTarget: '.err-block',
                    errorMsg: '개인정보 수집 및 이용에 동의 하셔야 이용 가능합니다.'
                },
                sympCd: {
                    required: true,
                    msgTarget: '.topic-msg',
                    errorMsg: '정확한 제품증상을 선택해 주세요.'
                },
                sympSubCode: {
                    required: true,
                    msgTarget: '.sub-topic-msg',
                    errorMsg: '정확한 세부 증상을 선택해 주세요.'
                },
                sympCodeThree: {
                    required: true,
                    msgTarget: '.three-topic-msg',
                    errorMsg: '정확한 세부 증상을 선택해 주세요.'
                },
                // bdType: {
                //     required: true,
                //     msgTarget: '.bd-type-msg',
                //     errorMsg: '건물 유형을 선택해 주세요.'
                // },
                stylerDt: {
                    required: true,
                    msgTarget: '.styler-dt-msg',
                    errorMsg: '구매시기를 선택해 주세요.'
                },
                fan: {
                    required: true,
                    msgTarget: '.fan-msg',
                    errorMsg: '실외기 위치를 선택해 주세요.'
                },
                addFan: {
                    required: true,
                    msgTarget: '.add-fan-msg',
                    errorMsg: '실외기 위치를 선택해 주세요.'
                },
                installType: {
                    required: true,
                    msgTarget: '.install-type-msg',
                    errorMsg: '설치 형태를 선택해 주세요.'
                },
                tvPosition: {
                    required: true,
                    msgTarget: '.tv-position-msg',
                    errorMsg: '설치 위치를 선택해 주세요.'
                },
                userNm: {
                    required: true,
                    maxLength: 30,
                    pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
                    msgTarget: '.err-block',
                    errorMsg: '이름을 입력해 주세요.',
                    patternMsg: '이름은 한글 또는 영문으로만 입력해 주세요.'
                },
                phoneNo: {
                    required: true,
                    minLength: 10,
                    maxLength: 11,
                    msgTarget: '.err-block',
                    errorMsg: '정확한 휴대폰 번호를 입력해 주세요.',
                    patternMsg: '정확한 휴대폰 번호를 입력해 주세요.',
                    validate : function(value){
                        return validatePhone(value);
                    } 
                },
                zipCode: {
                    required: true,
                    msgTarget: '.address-err-msg',
                    errorMsg: '정확한 주소를 입력해 주세요.'
                },
                userAddress: {
                    required: true,
                    msgTarget: '.address-err-msg',
                    errorMsg: '정확한 주소를 입력해 주세요.'
                },
                detailAddress: {
                    required: true,
                    msgTarget: '.address-err-msg',
                    errorMsg: '정확한 주소를 입력해 주세요.'
                },
                date: {
                    required: true,
                    msgTarget: '.calendar-area .date .err-msg',
                    errorMsg: '날짜를 선택해 주세요.'
                },
                time: {
                    required: true,
                    msgTarget: '.calendar-area .time .err-msg',
                    errorMsg: '시간을 선택해 주세요.'
                }
            }

            vcui.require(['ui/validation', 'ui/modal', 'ui/selectbox', 'ui/imageMovFileInput', 'support/common/searchModelNew.min'], function () {
                validation = new vcui.ui.CsValidation('.step-area', {register:register});
                addressFinder = new AddressFind();
                
                if (!isLogin) {
                    authManager = new AuthManager({
                        elem: {
                            popup: '#certificationPopup',
                            name: '#authName',
                            phone: '#authPhoneNo',
                            number: '#authNo'
                        },
                        register: {
                            authName: {
                                required: true,
                                maxLength: 30,
                                pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
                                msgTarget: '.err-block',
                                errorMsg: '이름을 입력해 주세요.',
                                patternMsg: '이름은 한글 또는 영문으로만 입력해 주세요.'
                            },
                            authPhoneNo: {
                                required: true,
                                minLength: 10,
                                maxLength: 11,
                                msgTarget: '.err-block',
                                errorMsg: '정확한 휴대폰 번호를 입력해 주세요.',
                                patternMsg: '정확한 휴대폰 번호를 입력해 주세요.',
                                validate : function(value){
                                    return validatePhone(value);
                                } 
                            },
                            authNo:{
                                required: true,
                                msgTarget: '.err-block',
                                errorMsg: '인증번호를 입력해 주세요.',
                            }
                        }
                    });
                }

                //BTOCSITE-77120 고객지원 > 출장예약 > 소음증상일 때 파일업로드 기능 추가
                self.$cont.find('.ui_imageinput').vcImageMovFileInput({
                    regex: /[?!,&^~]/, 
                    format: 'mkv|mp4|m4v|flv|avi|wmv|mov|m4r|m4a',
                    fileNameSize : 100,
                    totalSize: 9 * 1024 * 1024, 
                    individual: {size: 9 *  1024 * 1024},
                    message: {
                        name: '파일 명에 특수기호(? ! , . & ^ ~ )를 제거해 주시기 바랍니다.',
                        format: 'mkv, mp4, m4v, flv, avi, wmv, mov, m4r, m4a 파일만 첨부 가능합니다.',
                        size: '첨부파일 전체 용량은 9MB 이내로 등록 가능합니다',
                        nameLength : '첨부파일 이름은 확장자 포함 50자 이내로 등록 가능합니다.'
                    }
                });

                // 하이런 시스템 점검 테스트
                //$('#hiDownTimeFlag').val('Y')

                self.bindEvent();
                self.checkHirunTimeFlag(); // Hirun 점검공지

                //BTOCSITE-64827 고객지원 > 출장예약 > 모바일 > 날짜/시간 선택 UI 변경
                self.$dateWrap.calendar({inputTarget:'#date'});
                self.$timeWrap.timeCalendarNew({inputTarget:'#time'}); // BTOCSITE-45859 홈페이지 (야간) 출장 예약 서비스 준비
                self.$cont.vcSearchModelNew({
                    useCookie: !self.hirun,
                    reset: self.hirun
                });

                lgkorUI.hideLoading();
            });


            // BTOCSITE-35243 홈페이지 고객지원 회원기반 시범운영 (출장서비스)
            // var loginEnterPopup = $('#loginEnterPopup');
            // var loginurl = '/sso/api/Login';
            // var joinurl = '';
            // if(window.LGEAPPHostName === 'localhost' || window.LGEAPPHostName === 'wwwdev50.lge.co.kr'){
            //     joinurl = "https://devmember.lge.co.kr/auth/comnInfo.do?client_id=lge-main-integration&redirect_uri=https://www.lge.co.kr/sso/api/emp/Login?state=/&_ga=2.67623121.1774874568.1681081962-1788382530.1680822829&_gl=1*13flv1u*_ga*MTc4ODM4MjUzMC4xNjgwODIyODI5*_ga_ZBLV8D536G*MTY4MTEwMDM1OC4xMi4xLjE2ODExMDY2MDcuNjAuMC4w";
            // }else{
            //     joinurl = "https://member.lge.co.kr/auth/comnInfo.do?client_id=lge-main-integration&redirect_uri=https://www.lge.co.kr/sso/api/emp/Login?state=/&_ga=2.67623121.1774874568.1681081962-1788382530.1680822829&_gl=1*13flv1u*_ga*MTc4ODM4MjUzMC4xNjgwODIyODI5*_ga_ZBLV8D536G*MTY4MTEwMDM1OC4xMi4xLjE2ODExMDY2MDcuNjAuMC4w";
            // }

            // if(!loginEnterPopup.length){
            //     var poptemplate = vcui.template(loginEnterPopupTemplate, {joinurl:joinurl, loginurl:loginurl});
            //     $('body').append(poptemplate);
            // }    
            if (!isLogin) {
                $('#loginEnterPopup').vcModal();
            }
            
            // BTOCSITE-41934 고객지원 출장서비스예약 로그인팝업
            $('.loginPopup').find('.ui_modal_close').on('click', function(){
                $(window).trigger("toastshow", '고객지원 홈으로 이동합니다.');
                
                setTimeout(function(){
                    location.href = "/support";
                }, 100);
            });

            self.replaceTitleText();
        },
        // BTOCSITE-47599 로그인 후, 정보 '선택해 주세요' or '입력해 주세요' 부분 문구 정비
        replaceTitleText: function(){
            if(!lgkorUI.isLogin) return;
    
            var isUserNm = $('#userNm').val() != '',
                isPhoneNo= $('#phoneNo').val() != '',
                isZipCode = $('#useZipCode').val() != '';
    
            if(isUserNm && isPhoneNo && isZipCode) {
                var title = $('.tit.re-text');
                var text = title.html();
                title.html(text.replace('입력해', '확인해'));
            }
        },
        // BTOCSITE-15298 HiRUN 연동 제품, 실외기 2인1조 서비스 필요 건 출장예약 차단
        // BTOCSITE-68698 고객지원 > 출장예약 > 시스템에어컨 > 2인1조 관련 개선사항
        checkHirunAndInfo : function() {
            var self = this;
            var category = $('#category').val();
            var subCategory = $('#subCategory').val();
            var sympCd = $('input[name=sympCd]:checked').val(); // 증상
            var sympSubCode = $('#sTopic01Select').val();
            var sympCodeThree = $('#sTopic02Select').val();
            var fan = $('input[name=fan]:checked').val();
            var addFan = $('input[name=addFan]:checked').val();

            var param = {
                sympCd : sympCd,
                sympSubCode : sympSubCode,
                sympCodeThree: sympCodeThree,
                fan : fan,
                addFan : addFan
            };

            var isHirun = self.checkHirun(); //BTOCSITE-31948 홈서비스 통합 출장 서비스 주체 변화 (23/3/1 시행)
            var isCate = category == 'CT50019183' ? true : false; // CT50019183 에어콘
            var isSubCate = isHirun ? true : false; // CT50019259 시스템/천장형, CT50019244 업소용에어컨

            if(!isCate && !isSubCate) { return }

            var isFan = (/베란다 난간/.test(fan) || /건물 외벽 앵글/.test(fan) || /건물 밖 실외기실/.test(fan)) ? true : false; // 베란다난간, 건물외벽, 건물밖
            var isAddFan = (addFan == 1 || addFan == 2) ? true : false; // 2층, 3층이상
            var isEmpty = Object.values(param).includes(undefined) || Object.values(param).includes(null) || Object.values(param).includes('');
            
            if(!isEmpty && isCate && isSubCate && isFan && isAddFan){
                self.requestHirun();
            }
        },
        checkHirunTimeFlag: function() {
            var self = this;
            var category = self.$cont.find('#category').val();
            var subCategory = self.$cont.find('#subCategory').val();

            if (category == 'CT50019183' && (subCategory == 'CT50019259' || subCategory == 'CT50019244') && $('#hiDownTimeFlag').val() == 'Y') {                    
                lgkorUI.alert('(자세한 내용은 공지사항을 확인하시기 바랍니다.)<br>점검시간 : '+ $('#hirunDownStartTime').val() +' ~ '+ $('#hirunDownEndTime').val(),{
                    title: '시스템 점검 중으로, <br>\'시스템에어컨\', \'업소용 스탠드형\'<br>신청 및 조회가 불가합니다.'
                });
                self.hirun = true;
            }else{
                self.hirun = false;
            }
        },
        setTopicList: function(data) {
            var self = this;
            var html;
            var success = (data.topicList instanceof Array && data.topicList.length) ? true : false;

            if (success) {
                html = vcui.template(topicTmpl, data);
                self.$topicList.html(html);
            }
        },
        //BTOCSITE-69159 고객지원 > 출장예약 > 에어컨 > 설치장소 추가
        reRequestTopic: function() {
            var self = this;

            var param = {
                serviceType:$('#serviceType').val(),
                category: $('#category').val(),
                categoryNm: $('#categoryNm').val(),
                subCategory: $('#subCategory').val(),
                subCategoryNm: $('#subCategoryNm').val(),
                productCode: $('#productCode').val(),
                purpose: $('#purpose').val(),
            }

            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(self.resultUrl, param, function(result) {
                var resultData = result.data;
                self.setTopicList(resultData);
                lgkorUI.hideLoading();
            });
        },
        requestSub1Topic: function(url, param) {
            var self = this;

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(url, param, function(result) {
                var data = result.data,
                    html;
                html = vcui.template(sub1TopicTmpl, data);

                self.$subTopicWrap.show();
                self.$sub1TopicBox.show();
                self.$sub1TopicSelect.html(html);
                self.$productProblemsBox.find('#sub-topic-msg').hide();
                self.$sub1TopicSelect.vcSelectbox('update');

                self.$sub1TopicBox.find('.ui-selectbox-wrap').find('.ui-select-button').trigger('click'); // 증상2 자동 열림
                self.$sub1TopicBox.find('.ui-selectbox-list').show();

                lgkorUI.hideLoading();
            });
        },
        requestSub2Topic: function(url, param) {
            var self = this;

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(url, param, function(result) {
                var data = result.data,
                    html;
                html = vcui.template(sub2TopicTmpl, data);
                
                self.$sub2TopicBox.show();
            
                self.$sub2TopicSelect.html(html);
                self.$productProblemsBox.find('#three-topic-msg').hide();
                self.$sub2TopicSelect.vcSelectbox('update');

                //BTOCSITE-59670 고객지원 > 증상 선택시 2depth와 3depth 동일 증상이면 선택 예외처리 요청
                var timeout = null;
                var arr = data.threeTopicList;
                if(arr.length === 1) {
                    self.$sub2TopicSelect.vcSelectbox('selectedIndex', 1, true);
                    
                    clearTimeout(timeout);
                    tiemout = setTimeout(function() {
                        self.$sub2TopicSelect.vcSelectbox('update');
                        self.$sub2TopicSelect.trigger('click');	
                    }, 10);
                }

                self.$sub2TopicBox.find('.ui-selectbox-wrap').find('.ui-select-button').trigger('click'); // 증상2 자동 열림
                self.$sub2TopicBox.find('.ui-selectbox-list').show();
                lgkorUI.hideLoading();
            });
        },
        requestSolutions: function(url, param) {
            var self = this;

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(url, param, function(result) {
                var data = result.data;

                // BTOCSITE-17439 출장서비스예약 > 챗봇 이용 권유를 위한 기능 추가
                if (data.resultFlag == 'Y') {
                    self.$solutionsBanner.show();
                } else {
                    self.$solutionsBanner.hide();
                }

                
                // BTOCSITE-17439 출장서비스예약 > 챗봇 이용 권유를 위한 기능 추가
                if (data.resultFlag == 'Y') {
                    //self.$solutionsBanner.show();
                    // var alertMsg ='선택하신 증상은 <em class="color-3">챗봇 상담</em>으로 문제 해결 가능합니다. 계속해서 출장 접수를 원하시면 출장 접수 버튼을 눌려주세요.';
                    // lgkorUI.confirm(alertMsg,{
                    // 	typeClass:'type2',
                    // 	title:'',
                    // 	okBtnName: '챗봇상담',
                    // 	cancelBtnName: '출장접수',
                    // 	ok: function() {
                    // 		var subTopic = $('input[name=subTopic]:checked').attr('data-sub-topic-name');
                    // 		var speech = $('#subCategoryNm').val() + ' ' + subTopic;
                    // 		var chatUrl = lgkorUI.getChatDomain() + "/kr/index.html?service=cs&speech=" + encodeURIComponent(speech);
                    // 		lgkorUI.getChatPinCodeAsUrl(chatUrl, 450, 760);
                            
                    // 	},
                    // 	cancel: function() {}
                    // });

                    //BTOCSITE-64829 고객지원 > 출장예약 > 스스로 해결 콘텐츠 제공
                    self.requestQna();
                    //BTOCSITE-77120 고객지원 > 출장예약 > 소음증상일 때 파일업로드 기능 추가
                    var noiseFlag = self.$sub2TopicSelect.find("option:selected").data('noise');
                    if(noiseFlag != 'Y'){lgkorUI.scrollTo($('#addDesc'));}
                }
                //lgkorUI.scrollTo($('#addDesc'));
                self.$userInfoBox.addClass('open');
                lgkorUI.hideLoading();
            });
        },
        //BTOCSITE-64829 고객지원 > 출장예약 > 스스로 해결 콘텐츠 제공
        requestQna: function() {
            var $chatWrap = $('#solutionBanner');
            var url = $chatWrap.data('solutionListUrl');
            var param = {
                sympCd: $('input[name=sympCd]:checked').val(),
                sympSubCode: $('#sTopic01Select option:selected').val(),
                sympCodeThree: $('#sTopic02Select option:selected').val(),
                productCode: $('#productCode').val(),
            };
    
            lgkorUI.requestAjaxData(url, param, function(result){
                var data = result.data;
                var $qnaWrap = $chatWrap.find('.qna-list');
                var $solutionPopup = $('#solutionsPopup');

                if (data.resultFlag == 'Y'){
                    var qnaTmpl = 
                        '<dt>Q&amp;A를 보고 해결하기</dt>' +
                        '{{#each (item, index) in resultList}}' +				
                        '<dd><span class="blind">질문</span><button type="button" data-href="#solutionsPopup" data-item-id="{{item.itemId}}">{{ item.dpItemTitle}}</button></dd>'+
                        '{{/each}}';
                        
                    var html = vcui.template(qnaTmpl, data);
                    
                    $qnaWrap.find('dl').empty().html(html); 
                    $qnaWrap.show();

                    //solutionsPopup
                    var qnaPopTmpl = "";
                    for(var i=0; i < data.resultList.length ; i++){
                        qnaPopTmpl += '<div class="qna-cont" data-item-id="'+ data.resultList[i].itemId +'" style="display:none;">'+data.resultList[i].dpItemContents +'</div>'
                    }
                    $solutionPopup.find('.pop-conts').empty().html(qnaPopTmpl); 
                    
                } else {
                    $qnaWrap.hide();
                }
    
            },"GET", null, true);
        },
        setSolutions: function(param, isShown) {
            var self = this;
            var url = self.$solutionsPopup.data('listUrl');

            lgkorUI.requestAjaxData(url, param, function(result){
                self.$solutionsPopup.find('.pop-conts').html(result);
                self.$solutionsPopup.find('.pagination').pagination();
                
                if (isShown) {
                    self.$solutionsPopup.find('.ui_accordion').vcAccordion();
                } else {
                    self.$solutionsPopup.vcModal();
                }

                self.$solutionsPopup.find('.pagination').on('pageClick', function(e) {
                    var param = {
                            sympCd: $('input[name=sympCd]:checked').val(), // BTOCSITE-13336 출장 서비스 예약 > 고장증상 '세척서비스' 예약 가능하게 기능 수정 요청
                            sympSubCode: $('input[name=subTopic]:checked').val(), // BTOCSITE-13336 출장 서비스 예약 > 고장증상 '세척서비스' 예약 가능하게 기능 수정 요청
                            sympCodeThree: $('#serviceType').val(),
                            productCode : $('#productCode').val(),
                            page: e.page
                        };

                    self.setSolutions(param, true);
                });
            }, null, "html", true);
        },
        requestFastDate: function() {
            var self = this;
            
            var url = self.$stepInput.data('ajax'),
                param = validation.getAllValues(),
                result;
            // var productCode = $('#productCode').val();
            // BTOCSITE-3200 출장서비스 예약 > 추가정보_건물유형 수정 등 
            var productCode = self.getbdTypeParam();

            // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등
            // var purposeCode = $('#purpose').val();

            param = $.extend(param, {
                sympCd: $('input[name=sympCd]:checked').val(),
                sympSubCode: $('#sTopic01Select option:selected').val(),
                sympCodeThree: $('#sTopic02Select option:selected').val(),
                serviceType: $('#serviceType').val(),

                productCode: productCode,
                modelCode: $('#modelCode').val(),
                // purpose: purposeCode, // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등

                zipCode: self.$cont.find('#zipCode').val(),
                userAddress: self.$cont.find('#userAddress').val(),
                detailAddress: self.$cont.find('#detailAddress').val(),
                
                category: $('#category').val(),
                categoryNm: $('#categoryNm').val(),
                subCategory: $('#subCategory').val(),
                subCategoryNm: $('#subCategoryNm').val(),
            });

            self.$timeWrap.timeCalendarNew('reset').hide();

            result = validation.validate(['sympCd', 'sympSubCode', 'sympCodeThree', 'fan', 'addFan', 'installType', 'tvPosition', 'userNm', 'phoneNo', 'zipCode', 'userAddress', 'detailAddress', 'privcyCheck']);

            //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
            //스타일러 CT50019292, 도어 방향 전환 3AAAAAA

            var sympCodeThreeNm = $('#sTopic02Select option:selected').text(); //증상
            if(param.subCategory == 'CT50019292' && sympCodeThreeNm == '도어 방향 전환' && $('input[name=stylerDt]:checked').val() == null){
                validation.validate(['stylerDt']);
                return;
            }

            if (result.success) {
                // 증상 검증
                if(!self.$sub1TopicSelect.find('option:selected').val()) {
                    lgkorUI.scrollTo(self.$subTopicWrap);
                    self.$productProblemsBox.find('#sub-topic-msg').show();
                    return;
                }else {
                    if(!self.$sub2TopicSelect.find('option:selected').val()) {
                        lgkorUI.scrollTo(self.$subTopicWrap);
                        self.$productProblemsBox.find('#three-topic-msg').show();
                        return;
                    }
                    self.$productProblemsBox.find('#sub-topic-msg').hide();
                }

                //BTOCSITE-77120 고객지원 > 출장예약 > 소음증상일 때 파일업로드 기능 추가
                var files = self.$cont.find('.ui_imageinput').vcImageMovFileInput('getSelectFiles');
                if(!$.isEmptyObject(files)){
                    Object.keys(param).forEach(function(key) {
                        if(key.includes('imageFile')) {
                            delete param[key];
                        }
                    });
                }

                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(url, param, function(result) {
                    var data = result.data,
                        dateArr = data.dateList instanceof Array ? data.dateList : [],
                        fastDate;
                    if (data.resultFlag == 'Y') {
                        fastDate = dateUtil.format(data.fastDate + '' + data.fastTime + '00', 'yyyy년 MM월 dd일 hh시mm분');
                        self.$dateBeforeWrap.hide();
                        self.$stepEngineer.hide();	//추가 (서충원, 230620)

                        self.$stepDateBefore.addClass('open');
                        self.$stepDateBefore.find('.info-wrap .reser-info').eq(0).find('b.point').html(fastDate);
                        self.$stepDateBefore.find('.info-wrap .reser-info').eq(1).html('<span>주소 : </span>' + param.userAddress + " " + param.detailAddress);
                        self.$stepDateBefore.show();

                        self.$stepDate.find('.calendar-info .date').html(fastDate);

                        self.$stepArea.find('#deptCode').val(data.deptCode);
                        
                        // BTOCSITE-72562 출장접수 T/T 제공 로직 보완 진행 (일반, 우선건, 계절성)
                        var _dateList = vcui.array.map(dateArr, function(item, idx){
                            return item.split('/')[0];
                        });
                        $('.date-wrap').calendar('update', _dateList);

                        self.$stepDate.find('#date').val(data.fastDate);
                        self.$stepDate.find('#time').val(data.fastTime);


                        self.dateParam = result.param;

                        param = $.extend(param, { 
                            date: data.fastDate, 
                            time: data.fastTime, 
                            deptCode: self.$stepArea.find('#deptCode').val()
                        });

                        fastDateYn = "Y";
                        self.requestEngineerUnlock(param);

                        self.$scheduleBtnWrap.show();
                        lgkorUI.scrollTo(self.$stepDateBefore);
                    } else {
                        if (data.resultMessage) {
                            if (data.tAlert == 'Y') {
                                self.$stepInput.find('.step-btn-wrap').show();
                                self.$stepDate.hide();
                                //self.$stepDate.removeClass('active');
                                self.$stepEngineer.hide();
                                //self.$stepDateBefore.hide();
                            }

                            lgkorUI.alert("", {
                                title: data.resultMessage
                            });
                        }
                    }
                //BTOCSITE-74074  서비스 예약 조회 시 전화번호 값을 응답 못 받는 상황에서의 보완
                //lgkorUI.hideLoading(); //requestSelectDefaultEngineer 에서 hideLoading
                });
            }
        },
        requestDate: function() {
            var self = this;
            var url = self.$stepInput.data('ajax'),
                param = validation.getAllValues(),
                result;

            // var productCode = $('#productCode').val();
            // BTOCSITE-3200 출장서비스 예약 > 추가정보_건물유형 수정 등 
            var productCode = self.getbdTypeParam();

            // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등
            // var purposeCode = $('#purpose').val();

            param = $.extend(param, {
                category: $('#category').val(),
                categoryNm: $('#categoryNm').val(),
                subCategory: $('#subCategory').val(),
                subCategoryNm: $('#subCategoryNm').val(),
                productCode: productCode,
                sympCd: $('input[name=sympCd]:checked').val(),
                sympSubCode: $('#sTopic01Select option:selected').val(),
                sympCodeThree: $('#sTopic02Select option:selected').val(),
                serviceType: $('#serviceType').val(),
                deptCode: self.$stepArea.find('#deptCode').val(),
                lockId: $('#lockId').val(),
            });

            self.$timeWrap.timeCalendarNew('reset').hide();

            result = validation.validate(['sympCd', 'sympSubCode', 'sympCodeThree', 'fan', 'addFan', 'installType', 'tvPosition', 'userNm', 'phoneNo', 'zipCode', 'userAddress', 'detailAddress', 'privcyCheck']);

            //BTOCSITE-77120 고객지원 > 출장예약 > 소음증상일 때 파일업로드 기능 추가
            var files = self.$cont.find('.ui_imageinput').vcImageMovFileInput('getSelectFiles');
            if(!$.isEmptyObject(files)){
                Object.keys(param).forEach(function(key) {
                    if(key.includes('imageFile')) {
                        delete param[key];
                    }
                });
            }

            if (result.success) {
                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(url, param, function(result) {
                    var data = result.data,
                        dateArr = data.dateList instanceof Array ? data.dateList : [];
                    if (data.resultFlag == 'Y') {
                        if (dateArr.length) {

                            // BTOCSITE-72562 출장접수 T/T 제공 로직 보완 진행 (일반, 우선건, 계절성)
                            var _dateList = vcui.array.map(dateArr, function(item, idx){
                                return item.split('/')[0];
                            });
                            self.dateList = dateArr;
                            $('.date-wrap').calendar('update', _dateList);

                            self.dateParam = result.param;

                            self.$stepInput.find('.step-btn-wrap').hide();
                            self.$stepDate.show();
                            //self.$stepDate.addClass('active');
                            self.$stepEngineer.hide();
                        }
                    } else {
                        if (data.resultMessage) {
                            if (data.tAlert == 'Y') {
                                self.$stepInput.find('.step-btn-wrap').show();
                                self.$stepDate.hide();
                                //self.$stepDate.removeClass('active');
                                self.$stepEngineer.hide();
                            }

                            lgkorUI.alert("", {
                                title: data.resultMessage
                            });
                        }
                    }
                    lgkorUI.hideLoading();
                });
            }
        },
        // BTOCSITE-15298 HiRUN 연동 제품, 실외기 2인1조 서비스 필요 건 출장예약 차단
        // BTOCSITE-68698 고객지원 > 출장예약 > 시스템에어컨 > 2인1조 관련 개선사항
        requestHirun: function() {
            var self = this;
            var url = '/support/searchReserveBlock.lgajax';

            var param = {
                productCode : $('#productCode').val(), // 제품군
                sympCd : $('input[name=sympCd]:checked').val(), // 증상
                sympSubCode : $('#sTopic01Select').val(),
                sympCodeThree : $('#sTopic02Select').val()
            };

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(url, param, function(result) {
                var data = result;

                if (data.resultFlag == 'Y') {
                    var alertMsg = '안전한 점검을 위하여 서비스가 진행될 환경을 확인하고 있습니다. <br>LG전자 고객센터(<a href="tel:1544-7777">1544-7777</a>)로 연락주시면 상담을 도와드리겠습니다.';
                    lgkorUI.alert("", {
                        title: alertMsg,
                        ok: function(){
                            $('input[name=fan]').prop('checked', false);
                            $('input[name=addFan]').prop('checked', false);
                            self.$addFanBox.hide();
                            
                            $('input[name=sympCd]').prop('checked', false);
                            self.$sub1TopicBox.hide();
                            self.$sub2TopicBox.hide();

                            lgkorUI.scrollTo(self.$fanBox, $('.goods-selected-wrap').outerHeight());
                        }
                    });
                }
                lgkorUI.hideLoading();
            },"GET", null, true);
        },
        getbdTypeParam: function(){
            // BTOCSITE-3200 출장서비스 예약 > 추가정보_건물유형 수정 등
            // var self = this;
            // if ($('#subCategory').val() == 'CT50019259' && $('[name=bdType]:checked').val() == 0 && self.$bdTypeBox.data('current-product-code') != '' && self.$bdTypeBox.data('current-product-code') != undefined) {
            //     return self.$bdTypeBox.data('current-product-code');
            // } else {
            //     return $('#productCode').val();
            // }
            return $('#productCode').val();
        },
        setBdTypeParam: function(){
            var self = this;
            var category = $('#category').val(),
                subCategory = $('#subCategory').val(),
                arrSubCate = ['CT50019244', 'CT50172000', 'CT50019259'];


                
            if(category === 'CT50019183' && vcui.array.include(arrSubCate, subCategory)){
                var type = '';
                if(subCategory == 'CT50172000') {
                    //상업용 스탠드형 에어컨 
                    type = '주거공간';
                    self.bdTypePopup.find('[id=_bdType01]').prop('checked', true);
                }else if(subCategory == 'CT50019244' || subCategory == 'CT50019259') {
                    //상업용 스탠드 에어컨 , 상업용 천장형 에어컨
                    type = '상업공간';
                    self.bdTypePopup.find('[id=_bdType02]').prop('checked', true);
                }
                self.bdTypePopup.find(".text-area .type").html(type);
                self.bdTypePopup.find(".text-area .nm").html($('#subCategoryNm').val());
                self.bdTypePopup.vcModal({isHash:false});
            }   
        },
        setProductCode: function() {
            var self = this;
            var category = $('#category').val(),
                subCategory = $('#subCategory').val(),
                purpose = $('#purpose').val();
            // 에어컨                  CT50019183

            // 상업용 스탠드 에어컨     CT50019244  / COPAH
            // 가정용 천장형 에어컨     CT50172000  / RECRB
            // 상업용 천장형 에어컨     CT50019259  / COCRA
            // purpose : 주거(H) , 상업(C)

            if (category === 'CT50019183' && subCategory === 'CT50019244'){
                //스탠드형 에어컨
                if(purpose == 'H'){          // 주거
                    $('#productCode').val('STPAC');

                }else if(purpose == 'C'){    // 상업
                    $('#productCode').val('COPAH');
                }
          
            }else if(category === 'CT50019183' && (subCategory === 'CT50172000' || subCategory === 'CT50019259')){
                //가정용 천장형 에어컨
                if(purpose == 'H'){          // 주거
                    $('#productCode').val('RECRB');

                }else if(purpose == 'C'){    // 상업
                    $('#productCode').val('COCRA');
                }
            }
            self.checkHirun();
            self.reRequestTopic();
        },    
		// BTOCSITE-15196 동영상 파일 첨부 관련 아이폰 동영상
		renameFile: function(file){
			var name = file.name.substring(0, file.name.lastIndexOf("."));
			var ext = file.name.split('.').pop();
			var regex = /[?!,.&^~]/;

			if(regex.test(name)){
				name = vcui.string.replaceAll(name, regex, '_');
			}
			
			var newFileName = name+'.'+ext;
			var formData = new FormData();
				formData.append('file', file, newFileName);
				
			return formData.get('file');
		},
        requestTime: function(selectedDate) {
            var self = this,
                url = $('.calendar-area').data('timeUrl'),
                param = validation.getAllValues(),
                result;
            
            // var productCode = $('#productCode').val();
            // BTOCSITE-3200 출장서비스 예약 > 추가정보_건물유형 수정 등 
            var productCode = self.getbdTypeParam();

            // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등
            // var purposeCode = $('#purpose').val();

            param = $.extend(param, {
                category: $('#category').val(),
                categoryNm: $('#categoryNm').val(),
                subCategory: $('#subCategory').val(),
                subCategoryNm: $('#subCategoryNm').val(),
                productCode: productCode,
                sympCd: $('input[name=sympCd]:checked').val(),
                sympSubCode: $('#sTopic01Select option:selected').val(),
                sympCodeThree: $('#sTopic02Select option:selected').val(),
                serviceType: $('#serviceType').val(),
                deptCode: self.$stepArea.find('#deptCode').val(),
                lockId: $('#lockId').val(),
                date: selectedDate,
            });
            param['zipId'] = self.dateParam.zipId;
            param['custNo'] = self.dateParam.custNo;

            result = validation.validate(['sympCd', 'sympSubCode', 'sympCodeThree', 'fan', 'addFan', 'installType', 'tvPosition', 'userNm', 'phoneNo', 'zipCode', 'userAddress', 'detailAddress', 'privcyCheck']);

            //BTOCSITE-77120 고객지원 > 출장예약 > 소음증상일 때 파일업로드 기능 추가
            var files = self.$cont.find('.ui_imageinput').vcImageMovFileInput('getSelectFiles');
            if(!$.isEmptyObject(files)){
                Object.keys(param).forEach(function(key) {
                    if(key.includes('imageFile')) {
                        delete param[key];
                    }
                });
            }

            if (result.success) {
                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(url, param, function(result) {
                    var data = result.data;
                    self.$stepDate.find('#date').val(selectedDate);

                    if (data.resultFlag == 'Y') {
                        //BTOCSITE-64827 고객지원 > 출장예약 > 모바일 > 날짜/시간 선택 UI 변경
                        self.$timeWrap.timeCalendarNew('update', data.timeList).show();
                        //self.$timeWrap.find('.box-desc').hide();
                        //self.$timeWrap.find('.box-table').show();

                        self.$stepEngineer.hide();

                        //BTOCSITE-64827 고객지원 > 출장예약 > 모바일 > 날짜/시간 선택 UI 변경
                        // if ($(window).data('breakpoint').isMobile) {
                        //     // $('html,body').animate({
                        //     //     scrollTop: $('.time-wrap').parent().offset().top - $('.prod-selected-wrap').outerHeight()
                        //     // }, function() {
                        //     //     $('.time-wrap').parent().attr('tabindex', '0').focus().removeAttr('tabindex');
                        //     // });
                        //     lgkorUI.scrollTo($('.time-wrap').parent(), $('.goods-selected-wrap').outerHeight() + 100); // BTOCSITE-21157 고객지원 메뉴 - 포커스 이동 위치 수정
                        // }
                    } else {
                        if (data.resultMessage) {
                            if (data.tAlert == 'Y') {
                                self.$stepInput.find('.step-btn-wrap').show();
                                self.$stepDate.hide();
                                //self.$stepDate.removeClass('active');
                                self.$stepEngineer.hide();
                            }
                            
                            lgkorUI.alert("", {
                                title: data.resultMessage
                            });
                        }
                    }

                    lgkorUI.hideLoading();
                });
            }
        },
        requestEngineerUnlock: function(param) {//requestEngineer: function(param) {
            var self = this,
                unlockUrl = self.$stepDate.data('unlockUrl');
            var param = $.extend(param, self.dateParam);

            
            var unlockParam = {}; //unlockParam 빈 객체를 만들기

            if( $('#productCode').val() != undefined) { //빈값이진 undefined인지 확인 : undefined 가 아니면 unlockParam.productCode 는 밸류값이 들어간다
                unlockParam.productCode = $('#productCode').val()
            }
            if( $('#serviceType').val() != undefined) {
                unlockParam.serviceType = $('#serviceType').val()
            }
            if( $('#lockUserId').val() != undefined) {
                unlockParam.lockUserId = $('#lockUserId').val()
            }

            //BTOCSITE-74074  서비스 예약 조회 시 전화번호 값을 응답 못 받는 상황에서의 보완
            //lgkorUI.showLoading();
            $.ajax({
                type: "POST",
                async: true,
                url: unlockUrl,
                data: unlockParam,
                dataType: "json" , 
                success: function(result){

                    var data = result.data;
                    if (data.resultFlag === 'Y') {
                        self.requestSelectDefaultEngineer(param);
                    }
                },
                error:function(){ 
                }
            });
            //BTOCSITE-74074  서비스 예약 조회 시 전화번호 값을 응답 못 받는 상황에서의 보완
            //lgkorUI.hideLoading(); //requestSelectDefaultEngineer 에서 hideLoading
        },
        requestSelectDefaultEngineer: function(param) { //requestUnLock: function(param) {
            var self = this,
                url = self.$stepDate.data('ajax');

            var param = $.extend(param, { 
                'zipId': self.dateParam.zipId
            });

            lgkorUI.showLoading();
            $.ajax({
                type: "POST",
                async: true,
                url: url,
                data: param,
                dataType: "json" , 
                success: function(result){
                    var data = result.data;
                    
                    if (data.resultFlag === 'Y') {
                        $('#lockId').val(data.lockId);

                        //엔지니어정보 셋팅
                        self.setStepEngineer(data);
                    } else {
                        if (data.resultMessage) {
                            lgkorUI.alert("", {
                                title: data.resultMessage
                            });
                        }
                    }
                    lgkorUI.hideLoading();
                },
                error:function(){ 
                }
            });
        },
        requestComplete: function() {
            var self = this;

            // BTOCSITE-3200 출장서비스 예약 > 추가정보_건물유형 수정 등 
            // if ($('[name=bdType]:checked').val() == 0 && self.$bdTypeBox.data('current-product-code') != '' && self.$bdTypeBox.data('current-product-code') != undefined) {
            //     $('#productCode').val(self.$bdTypeBox.data('current-product-code'));
            // }

            var url = self.$submitForm.data('ajax');
            var param = validation.getAllValues();

            param = $.extend(param, self.dateParam);

            param = $.extend(param, {
                category: $('#category').val(),
                categoryNm: $('#categoryNm').val(),
                subCategory: $('#subCategory').val(),
                subCategoryNm: $('#subCategoryNm').val(),
                productCode: $('#productCode').val(),
                modelCode: $('#modelCode').val(),

                rental: !$('#rental').val() ? 'N' : $('#rental').val(),
                buyingdate: $('#buyingdate').val(),
                
                sympCd: $('input[name=sympCd]:checked').val(),
                sympSubCode: $('#sTopic01Select option:selected').val(),
                sympCodeThree: $('#sTopic02Select option:selected').val(),
                serviceType: $('#serviceType').val(),
                zipCode: self.$cont.find('#zipCode').val(),
                userAddress: self.$cont.find('#userAddress').val(),
                detailAddress: self.$cont.find('#detailAddress').val(),
                
                date: self.$stepDate.find('#date').val(),
                time: self.$stepDate.find('#time').val(),
                deptCode: self.$stepArea.find('#deptCode').val(),
                lockId: $('#lockId').val(),
                topLoginFlag: lgkorUI.isLogin ? 'Y' : 'N',

            });

            // BTOCSITE-22255 [약관] 비회원 출장서비스 신청 시 마케팅정보수신 약관 표출 요청
            if(self.$marketingAgree.length > 0) {
                var marketingUseAgreeYn = $('input[name=marketingCheck]').prop('checked') ? 'Y' : 'N';
                param = $.extend(param, {marketingUseAgreeYn: marketingUseAgreeYn});
            }

            // BTOCSITE-29994 출장서비스 - 희망 일시 선택 후, 고객이 원하는 약속 일자 선택 가능 여부 데이터를 집계
            // BTOCSITE-31616 파일럿 종료) 출장서비스 - 희망 일시 선택 후, 고객이 원하는 약속 일자 선택 가능 여부 데이터를 집계
            // var desiredContent = $('#desiredServeyContent').val();
            // if(desiredContent.length > 0) {
            //     param = $.extend(param, {desiredServeyContent: vcui.string.stripScripts(desiredContent)});
            // }

            param = $.extend(param, self.addInstCode(param)); //BTOCSITE-76141 고객지원 > 출장예약 > 설치유형 코드화

            //BTOCSITE-77120 고객지원 > 출장예약 > 소음증상일 때 파일업로드 기능 추가
            var formData = new FormData;
			for (var key in param) {
				(key.includes('imageFile') && param[key]) ? param[key] = self.renameFile(param[key]) : '';    
				formData.append(key, param[key]);
			}

            lgkorUI.showLoading();
            lgkorUI.requestAjaxFileData(url, formData, function(result) {
                var data = result.data;

                // 로그인 체크
                if(data.loginCheckFlag == 'N') {
                    lgkorUI.hideLoading();
                    $('#loginPopup').vcModal();
                    return;
                }
           
                if (data.resultFlag == 'Y') {
                    if (self.isOneView == 'Y') {
                        lgkorUI.hideLoading();
                        lgkorUI.alert('', {
                            title:'예약이 완료 되었습니다.',
                            okBtnName: '확인',
                            ok: function() {
                                window.close();
                            }
                        });   
                    } else {
                        $('#acptNo').val(data.acptNo);
                        self.$submitForm.submit();
                    }
                } else {
                    lgkorUI.hideLoading();
                    if (data.resultMessage) {
                        lgkorUI.alert("", {
                            title: data.resultMessage,
                            ok: function() {
                                if (self.isOneView == 'Y') {
                                    if (data.resultMessage.indexOf('휴대전화번호') != -1) {
                                        $('#phoneNo').prop('readonly', false);
                                        $('#phoneNo').focus();
                                    }
                                }
                            }
                        });
                    }
                }
            }, 'POST');
        },

        //BTOCSITE-9289 : 페이지 나갈때 param보내는 기능 끄기
        clearPageLeventEvents : function() {
            $(window).off("beforeunload");
        },

        // 마케팅 동의
        //BTOCSITE-31948 홈서비스 통합 출장 서비스 주체 변화 (23/3/1 시행)
        showMarketingAgree : function(){
            var self = this,
                subCategory = $('#subCategory').val(),
                isHirun = self.checkHirun();
                
            if (isHirun && !isLogin){
                self.$allAgree.show();
                self.$marketingAgree.show();
            }else{
                self.$allAgree.hide();
                self.$marketingAgree.hide();
            }
        },
        // 에어컨 > 업소용,시스템(상업공간) Hirun
        checkHirun: function(){

            // 상업용 스탠드 에어컨 CT50019244
            // 가정용 천장형 에어컨 CT50172000
            // 상업용 천장형 에어컨 CT50019259
            // purpose : 주거공간 H, 상업공간 C
            
            var subCategory = $('#subCategory').val(),
                //bdType = $('[name=bdType]:checked').val(),
                purpose = $('#purpose').val() == 'C' ? true : false,
                isHirun = purpose && (subCategory == 'CT50019244' || subCategory == 'CT50019259'  || subCategory == 'CT50172000');

            return isHirun;
        },
        setPreInspecInfo: function(){
            //BTOCSITE-86673 홈페이지 내 D_10 사전점검 항목 추가
            var self = this,
                category = $('#category').val(),
                $info = self.$cont.find('#preInspecInfo');
            var isHirun = self.checkHirun();

            if (category == 'CT50019183' && !isHirun) {
                $info.show();
            }else{
                $info.hide();
            }
        },
        setStepEngineer: function(data) {
            var self = this,
                isHirun = self.checkHirun();
                         
            var date = $('#date').val(),
                time = $('#time').val(),
                userAddress = $('#userAddress').val(),
                detailAddress = $('#detailAddress').val(),
                dateTime = dateUtil.format(date + '' + time + '00', 'yyyy년 MM월 dd일 hh시mm분');
    
            self.$stepEngineer.find('.date').text(dateTime);
            self.$stepEngineer.find('.text').find('span').text(userAddress + ' ' + detailAddress);
            self.$stepEngineer.show();

            if(isHirun && !!data.engineerList){
                var dataEngineer = data.engineerList[0];
                $('#engineerNm').val(dataEngineer.engineerName);
                $('#engineerCode').val(dataEngineer.engineerCode);
                $('#centerNm').val(dataEngineer.centerName);
                $('#centerCode').val(dataEngineer.centerCode);
                
                self.dateParam['resrvSeq'] = dataEngineer.resrvSeq;
            }
            
            if(fastDateYn == "Y"){
                self.$stepEngineer.hide();
            }else{
                self.$stepEngineer.show();
            }					

        },
        checkSalesInfo: function() {
            var self = this,
                param = validation.getAllValues(),
                category = $('#category').val(),
                subCategory = $('#subCategory').val();
                // BTOCSITE-69770 서비스예약시, 폭염특보 안내문 반영의 건
                infoBoxAircon = self.$cont.find('.inst-move-info-aircon');
                infoBoxAircon.hide();

            
                if (category === 'CT50019183') {
                    if(param.fan === '베란다 난간' ||  param.fan === '건물 외벽 앵글' || param.fan === '건물 밖 실외기실') {
                        /* if(param.fan && param.addFan) {
                            self.$productProblemsBox.addClass('open');
                            //lgkorUI.scrollTo(self.$productProblemsBox);
                            lgkorUI.scrollTo($('#addFanBox'));
                        } else {
                            lgkorUI.scrollTo($('#addFanBox'));
                        } */
                        if(param.addFan) {
                            self.$productProblemsBox.addClass('open');
                            lgkorUI.scrollTo($('#productProblems'));
                        }
                    } else {
                        if(param.fan) {
                            self.$productProblemsBox.addClass('open');
                            lgkorUI.scrollTo($('#addFanBox'));
                        }
                    }
                    // BTOCSITE-69770 서비스예약시, 폭염특보 안내문 반영의 건
                    // if(param.fan === '옥상' ||  param.fan === '1층 또는 지면') {
                    //     infoBoxAircon.show();
                    // } else {
                    //     infoBoxAircon.hide();
                    // }
                } else {
                    if (subCategory === "CT50019309" || subCategory === "CT50019275") {
                        if(param.installType) {
                            self.$productProblemsBox.addClass('open');
                            lgkorUI.scrollTo(self.$productProblemsBox);
                        } 
                    } else if (subCategory === "CT50019082" || subCategory === "CT50019037" || subCategory === "CT50019052" || subCategory === "CT50019067" || subCategory === "CT50109019"|| subCategory === "CT50109023") {
                        if(param.tvPosition) {
                            self.$productProblemsBox.addClass('open');
                            lgkorUI.scrollTo(self.$productProblemsBox);
                        }
                    } else {
                        self.$productProblemsBox.addClass('open');
                        lgkorUI.scrollTo(self.$productProblemsBox);
                    }
                
                }
            
        },
        setInstallInfo: function(data){
            var self = this,
                data = data;

            self.$saleInfoBox.hide();


            var instExistFlag = false; 
            //에어컨
            if (data.category == 'CT50019183') {
                if (data.subCategory != "CT50019229") {
                    self.$saleInfoBox.show();
                    self.$fanBox.show();
                    instExistFlag = true;
                }else{
                    self.$fanBox.hide();
                    instExistFlag = false;
                }
            }else{
                self.$fanBox.hide();   
            }

            //세탁기/건조기/의류관리기
            if (data.category == 'CT50019274') {
                // 드럼 세탁기 OR 의류 건조기 선택 시
                if (data.subCategory == "CT50019309" || data.subCategory == "CT50019275") {
                    self.$saleInfoBox.show();
                    self.$installTypeBox.show();
                    instExistFlag = true;
                } else {
                    self.$installTypeBox.hide();
                    instExistFlag;
                }
            }else{
                self.$installTypeBox.hide(); 
            }

            //TV/프로젝트 
            if (data.category == 'CT50019021') { 
                // TV/프로젝터 > 올레드, 울트라HD, LED/LCD, PDP 선택 시
                if (data.subCategory == "CT50019082" || data.subCategory == "CT50019037" || data.subCategory == "CT50019052" || data.subCategory == "CT50019067" || data.subCategory == "CT50109019" || data.subCategory == "CT50109023") {
                    self.$saleInfoBox.show();
                    self.$tvPositionBox.show();
                    instExistFlag = true;
                } else {
                    self.$tvPositionBox.hide(); 
                    instExistFlag = false;
                }   
            }else{
                self.$tvPositionBox.hide(); 
         

            }


        $button = $('.prod-model-box .btn-prod-next');
            if(instExistFlag){
				$button.text('이어서 설치 정보 선택하기');
			}else{
				$button.text('이어서 증상 선택하기');
            }


        },
        setInstMoveInfo: function(data){
            var self = this,
                data = data,
                infoBox = self.$cont.find('.inst-move-info');
            
            var eqSubArr = ['CT50019309', 'CT50019275'];
            var neSubArr = ['CT50019229'];
        
            if(data.category == 'CT50019021' && !vcui.isEmpty(data.subCategory) && data.subCategory != 'CT50019022'){ //TV 제품군 > (빔 제외)
                infoBox.show();
            }else if(data.category == 'CT50019274' && vcui.array.include(eqSubArr, data.subCategory)) { //세탁기/건조기 > (드럼세탁기, 건조기 대상)
                infoBox.show();
            }else if(data.category == 'CT50019183' && !vcui.isEmpty(data.subCategory) && !(vcui.array.include(neSubArr, data.subCategory))) { //에어컨 > (창문형/이동식 제외)
                infoBox.show();
            }else {
                infoBox.hide();
            }
        },
        setInstCode: function (){
            //BTOCSITE-80022 고객지원 > 메인 리뉴얼 > 서비스 재접수
            var self = this;
            var url = location.search;
            if (url.indexOf("?") > -1) {
                var search = url.substring(1);
                var searchObj = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
                
                if(searchObj.setType != undefined){
                    var setType = searchObj.setType;
                    var type = searchObj.setType.slice(0,2);
    
                    switch(type) {
                        case "WM": //세탁기
    
                            var insType = setType == 'WM01' ? '단독설치' : setType == 'WM02' ? '직렬설치' : setType == 'WM03' ? '병렬설치' : '';
                            $('#installTypeBox').find('input[value="'+insType+'"]').prop('checked', true).trigger('change');
                            break;
                        case "TV": //TV
    
                            var tvPos = setType == 'TV01' ? '벽걸이 설치' : setType == 'TV02' ? '스탠드 설치' : setType == 'TV03' ? '천장 설치' : setType == 'TV04' ? '기타' : '';
                            $('#tvPositionBox').find('input[value="'+tvPos+'"]').prop('checked', true).trigger('change');
                            if(searchObj.setTypeDesc != undefined) $('#tvPositionEtc').val(searchObj.setTypeDesc);
                            break;
                        case "AC": //에어컨
    
                            if(searchObj.fan != undefined) $('#fanBox').find('input[value="'+searchObj.fan+'"]').prop('checked', true).trigger('change');
                            if(searchObj.addFan != undefined) $('#addFanBox').find('input[value="'+searchObj.addFan+'"]').prop('checked', true).trigger('change');                        
                            if(searchObj.setTypeDesc != undefined) $('#fanEtc').val(searchObj.setTypeDesc);          
                            break;
                    }
                }
            }else{
                return;
            }
        },
        addInstCode: function (data){
            //BTOCSITE-76141 고객지원 > 출장예약 > 설치유형 코드화
            var eqSubArr = ['CT50019309', 'CT50019275'];
            var neSubArr = ['CT50019229'];
            var objData = {};
            
            if(data.category == 'CT50019021' && data.subCategory != 'CT50019022'){ //TV 제품군 > (빔 제외)
                objData = {
                    setType: data.tvPosition == '벽걸이 설치' ? 'TV01' : data.tvPosition == '스탠드 설치' ? 'TV02' : data.tvPosition == '천장 설치' ? 'TV03' : data.tvPosition == '기타' ? 'TV04' : '',
                    setTypeDesc: data.tvPositionEtc
                }
            }else if(data.category == 'CT50019274' && vcui.array.include(eqSubArr, data.subCategory)) { //세탁기/건조기 > (드럼세탁기, 건조기 대상)
                objData = {
                    setType: data.installType == '단독설치' ? 'WM01' : data.installType == '직렬설치' ? 'WM02' : data.installType == '병렬설치' ? 'WM03' : '',
                }
            }else if(data.category == 'CT50019183' && !(vcui.array.include(neSubArr, data.subCategory))) { //에어컨 > (창문형/이동식 제외)
                objData = {
                    setType: data.fan == '베란다 난간' ? 'AC01' : data.fan == '건물 외벽 앵글' ? 'AC02' : data.fan == '건물 밖 실외기실' ? 'AC03' : data.fan == '옥상' ? 'AC04' : data.fan == '베란다 내부' ? 'AC05' : data.fan == '실내 실외기' ? 'AC06' : data.fan == '1층 또는 지면' ? 'AC07' : data.fan == '2단설치' ? 'AC08' : data.fan == '기타' ? 'AC09' : '', 
                    setTypeAdd: data.addFan,
                    setTypeDesc: data.fanEtc  
                }
            }
            return objData;
        },
        // BTOCSITE-62364 모델번호, 제조번호 입력
        // ##### 제조번호 규칙 #####
        // 제조번호 자리수는 10자리에서 18자리까지이다. 숫자3자리로 시작한다.
        // 1. 자리수가 14자리 이하일 때는, 숫자3자리 + 숫자알파벳 7~11자리 이다. 
        //    패턴 : /^[0-9]{3}[A-Za-z0-9]{7,11}$/
        // 2. 자리수가 15자리에서 18자리 이하일 때는, 숫자3자리+ 숫자알파벳 9~11자리 + 숫자 1~4자리
        //    패턴 : /^[0-9]{3}[A-Za-z0-9]{9,11}[0-9]{1,4}$/

        validateModelSelectBox: function() {
            // 모델명/제조번호 
            var self = this;
            var $msg = self.$modelSearchBox.find('.success-msg');
            var $errmsg = self.$modelSearchBox.find('.success-msg.error');
            var snVal = self.$modelSearchBox.find('input[name="sn"]').val();
            var searchVal = self.$modelSearchBox.find('#search').val();
			var $cateWrap = self.$modelSearchBox.find('.cate-wrap');
			var $prodBtn = self.$modelSearchBox.find('.btn-prod-next');
            
			var modelCode = $('#modelCode').val();
            var salesModelCode = $('#salesModelCode').val();
			var categoryNm = $('#categoryNm').val();
			var subCategoryNm = $('#subCategoryNm').val();
            
            var less = /^[0-9]{3}[A-Za-z0-9]{7,11}$/.test(snVal); //자리수가 14자리 이하일 때는, 숫자3자리 + 숫자알파벳 7~11자리
            var over = /^[0-9]{3}[A-Za-z0-9]{9,11}[0-9]{1,4}$/.test(snVal); //자리수가 15자리~18자리 이하일 때는, 숫자3자리+ 숫자알파벳 9~11자리 + 숫자 1~4자리
			var isValidSn = false;
			var isValidModel = false;
			var isValidCate = false;
            var isCate = categoryNm != '' && subCategoryNm != '';

            //BTOCSITE-68698 고객지원 > 출장예약 > 시스템에어컨 > 2인1조 관련 개선사항
            if(self.hirun){
                $('.prod-model-box .btn-prod-next').prop('disabled', true);
                return;
            }

            if(snVal == '') {
                return;
            };

            if(less || over){
                isValidSn = true;
                $msg.show();
                $errmsg.hide();
                
            }else{
                $msg.hide();
                $errmsg.show();
            }

			if(modelCode == searchVal && salesModelCode != '' &&  modelCode != '' && searchVal != '' && isCate){
				isValidModel = true;
			}
			
			if(modelCode != searchVal && salesModelCode == '' && modelCode == '' && searchVal != '' && isCate){
				isValidCate = true;
			}
			
			if(modelCode != searchVal && searchVal != '' && isValidSn){
				$cateWrap.show();
			}else{
				$cateWrap.hide();
			}

            if(searchVal != '' && snVal != '' && isValidSn && (isValidModel || isValidCate)){

                //버튼 활성화
                $prodBtn.prop('disabled', false);
			}else{
				$prodBtn.prop('disabled', true);
			}
        },
        //BTOCSITE-64551 고객지원 > 출장접수 > 시스템에어컨 안내 추가
        showAirconText: function(){
            var idx = $('.prod-model-box.open').index();
            if(idx == 0) return;  //제품군 선택시 실행

            var self = this;
            var cate = $('#category').val();
            var subCate = $('#subCategory').val();
            var $txt = self.$modelSelectBox.find('.system-aircon-msg');
            var text = "";

            if(cate == 'CT50019183') { 				// 에어컨
                if(subCate == 'CT50172000'){ 	
                    	// 가정용 천장형 에어컨
                    text = "가정용 천장형 에어컨을 선택하셨군요. <br><br>";
                    text += "<em>현재 제품을 사용 중인 장소가 주거 공간이 맞나요?</em><br>";
                    text += "<em>(아파트, 빌라, 주택, 원룸)</em><br>";
                    text += "※ 기숙사 및 오피스텔(주거용 포함)은 상업 공간입니다. <br><br>";
                    text += "상업 공간에서 사용 중이시라면 '상업용 천장형 에어컨'을 선택해주세요. <br>";
                    text += "(상가, 사무실, 숙박업소, 학교, 관공서, 사무실/주거용 오피스텔, 기숙사, 종교 시설 등)";
                    
                    $txt.html(text).show();
                }else if(subCate == 'CT50019259'){	// 상업용 천장형 에어컨

                    text = "상업용 천장형 에어컨을 선택하셨군요. <br><br>";
                    text += "<em>현재 제품을 사용 중인 장소가 상업 공간이 맞나요?</em><br>";
                    text += "<em>(상가, 사무실, 숙박업소, 학교, 관공서, 사무실/주거용 오피스텔, 기숙사, 종교 시설 등)</em><br>";
                    text += "※ 기숙사 및 오피스텔(주거용 포함)도 상업 공간입니다.  <br><br>";
                    text += "주거 공간에서 사용 중이시라면 '가정용 천장형 에어컨'을 선택해주세요. <br>";
                    text += "(아파트, 빌라, 주택, 원룸)";

                    $txt.html(text).show();
                }else if(subCate == 'CT50019244'){	// 상업용 스탠드 에어컨

                    text = "상업용 스탠드 에어컨을 선택하셨군요. <br><br>";
                    text += "<em>현재 제품을 사용 중인 장소가 상업 공간이 맞나요?</em><br>";
                    text += "<em>(상가, 사무실, 숙박업소, 학교, 관공서, 사무실/주거용 오피스텔, 기숙사, 종교 시설 등)</em><br>";
                    text += "※ 기숙사 및 오피스텔(주거용 포함)도 상업 공간입니다.  <br><br>";
                    text += "주거 공간에서 사용 중이시라면 '스탠드형 에어컨'을 선택해주세요. <br>";
                    text += "(아파트, 빌라, 주택, 원룸)";

                    $txt.html(text).show();
                }else{
                    $txt.html("").hide();
                }
            }else{
                $txt.html("").hide();
            }
        },
        delModelValue: function() {
            var self = this;
            $('#categoryNm').val("");
            $('#subCategoryNm').val("");
            $('#category').val("");
            $('#subCategory').val("");
            $('#modelCode').val("");
            $('#productCode').val("");
            $('#salesModelCode').val("");
            $('#serialNumber').val("");
            //모델명/제조번호
            self.$modelSearchBox.find('[class^="success-msg"]').hide();
			self.$modelSearchBox.find('.cate-wrap').hide();
            self.$modelSearchBox.find('[id="sn"]').val("");
            self.$modelSearchBox.find('[id="search"]').vcInputClearButton('updateVal', '');
            self.$modelSearchBox.find('[id="prodCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
            self.$modelSearchBox.find('[id="prodSubCategorySelect"]').children('option:not(:first-child)').remove();
            self.$modelSearchBox.find('[id="prodSubCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
            //제품군 
            self.$modelSelectBox.find('[id="categorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
            self.$modelSelectBox.find('[id="subCategorySelect"]').children('option:not(:first-child)').remove();
            self.$modelSelectBox.find('[id="subCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');

        },
        // BTOCSITE-65147 고객지원 > 출장예약 > 세척서비스 추가
        cleaningBanner: function(){
            var self = this;
            var subCate = $('#subCategory').val();
            self.$cleanBanner = self.$cont.find('#cleanBanner');
            self.$cleanBannerBtn = self.$cleanBanner.find('.banner-button');
            self.$cleanBannerLink = self.$cleanBanner.find('.banner-link');
            if (subCate == 'CT50019199' || subCate == 'CT50019214' || subCate == 'CT50019229' || subCate == 'CT50108006' || subCate == 'CT50172000' || subCate == 'CT50019259'){
                // 에어컨
                self.$cleanBanner.show();
                self.$cleanBannerBtn.text("에어컨 세척 예약");
                self.$cleanBannerLink.attr("href", "/lg-best-care/home-appliance-cleaning#tab01")
            }else if (subCate == 'CT50019309' || subCate == 'CT50019324' || subCate == 'CT50109011' || subCate == 'CT50109012' || subCate == 'CT50109013'){
                // 세탁기
                self.$cleanBanner.show();
                self.$cleanBannerBtn.text("세탁기 세척 예약");
                self.$cleanBannerLink.attr("href", "/lg-best-care/home-appliance-cleaning#tab02")
            }else if (subCate == 'CT50019292'){
                // 의류관리기
                self.$cleanBanner.show();
                self.$cleanBannerBtn.text("의류관리기 세척 예약");
                self.$cleanBannerLink.attr("href", "/lg-best-care/home-appliance-cleaning#tab02")
            }else if (subCate == 'CT50019468' || subCate == 'CT50019483' || subCate == 'CT50109002' || subCate == 'CT50109003' || subCate == 'CT50019442' || subCate == 'CT50109005'){
                // 냉장고
                self.$cleanBanner.show();
                self.$cleanBannerBtn.text("냉장고 세척 예약");
                self.$cleanBannerLink.attr("href", "/lg-best-care/home-appliance-cleaning#tab03")
            }else if (subCate == 'CT50019873'){
                // 공기청정기
                self.$cleanBanner.show();
                self.$cleanBannerBtn.text("공기청정기 세척 예약");
                self.$cleanBannerLink.attr("href", "/lg-best-care/home-appliance-cleaning#tab04")
            }else if (subCate == 'CT50019890'){
                //제습기
                self.$cleanBanner.show();
                self.$cleanBannerBtn.text("제습기 세척 예약");
                self.$cleanBannerLink.attr("href", "/lg-best-care/home-appliance-cleaning#tab04")
            } 
            else {
                self.$cleanBanner.hide();
            }
        },

        //BTOCSITE-77120 고객지원 > 출장예약 > 소음증상일 때 파일업로드 기능 추가
        showFileUpload: function(){
            var self = this;

            var noiseFlag = self.$sub2TopicSelect.find("option:selected").data('noise');
            if(noiseFlag == 'Y'){
                self.$fileUpload.show();
            }else{
                self.$fileUpload.hide();
            }
        },
        //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
        showStylerDt: function(){
            var subCate = $('#subCategory').val(); 
            var sympCodeThreeNm = $('#sTopic01Select option:selected').text() || $('#sTopic02Select option:selected').text(); //증상

            //  의료관리기 cate : CT50019274 , subCate : CT50019292
            if(subCate === 'CT50019292' && sympCodeThreeNm === '도어 방향 전환'){ 
                $('input[name=stylerDt]').prop('checked', false); //구매정보 리셋
                $('#stylerDt').show(); 
                lgkorUI.scrollTo($('#stylerDt'));
            }else{
                $('#stylerDt').hide();
            }
        },
        bindEvent: function() {
            var self = this;
            
            $('[data-href="#ratesWarrantyGuidePopup"]').on('click', function() {
                lgkorUI.setAcecounter('www.lge.co.kr/acecount/engineerInfoClick.do', '/acecount/engineerInfoClickm.do');
            });
            // $('#saleInfo .form-infos').show(); //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응


            self.$cont.on('reset', function(e) {
                self.$stepArea.hide();
                //self.$selectedModelBar.hide();

                //로그인시에만 해당 탭 노출 (서충원, 230613)
                //if(isLogin){
                    //self.$tabWrap.removeClass('dpn');
                    
                    //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
                    // BTOCSITE-47599 로그인 후, 정보 '선택해 주세요' or '입력해 주세요' 부분 문구 정비
                    //$('#saleInfo').find('.tit-wrap .tit').text('1. 제품 구매 정보를 입력해 주세요');
                //}

                self.$prodWrap.show();
                self.$myModelWrap.show();
                
                if(isLogin) { // 모든 약관동의 해제
                    $(".agree-wrap input:checkbox").prop('checked', false);
                }

                //BTOCSITE-62364 모델번호, 제조번호 입력
                //모델명/제조번호
                self.delModelValue();
                $('.prod-model-box .btn-prod-next').prop('disabled', true);
                $('.prod-model-box .btn-prod-next').text('이어서 증상 선택하기');
                

                self.$topicList.empty();
                self.$solutionsBanner.hide();
                self.$fanBox.hide();
                // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등
                // BTOCSITE-31948 홈서비스 통합 출장 서비스 주체 변화 (23/3/1 시행)
                self.$bdTypeBox.hide().data('product-code', '');
                self.$saleInfoBox.hide(); //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
                self.$tvPositionBox.hide();
                self.$installTypeBox.hide();
                self.$addFanBox.hide();
                self.$stepInput.find('.step-btn-wrap').show();
                $('#stylerDt').hide(); //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응

                self.$sub1TopicBox.hide();
                self.$sub1TopicSelect.empty();
                self.$sub1TopicBox.find('.ui-selectbox-list ul').empty();
                
                self.$sub2TopicBox.hide();
                self.$sub2TopicSelect.empty();
                self.$sub2TopicBox.find('.ui-selectbox-list ul').empty();

                self.$scheduleBtnWrap.hide();
                self.$stepEngineer.hide();
                self.$stepDate.hide();
                self.$stepDateBefore.hide();

                // self.$productProblemsBox.removeClass('open'); //BTOCSITE-44580 증상선택
                self.$userInfoBox.removeClass('open');

                $('#rental').val("");
                $('#buyingdate').val("");

                //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
                // self.$salesDtWrap.children().eq(0).show();
                // self.$salesDtWrap.children().eq(1).hide();
                
                //리셋시 예약가능일자 조회 버튼 show
                self.$dateBeforeWrap.show();

                if (isLogin) {
                    var notInput = '#userNm, #phoneNo';
                    if ($('#detailAddress').data('defaultValue')) {
                        notInput += ', #zipCode, #userAddress, #detailAddress';
                        $('[data-default-value]').each(function() {
                            $(this).val($(this).data('defaultValue')).prop('readonly', true);
                        });
                    }
                    self.$marketingUseAgree.hide();
                }

                // BTOCSITE-27978 간편 출장서비스 접수 중 제품 재선택 시 입력창 disable해제
                if (!isLogin && self.isMainFlag == 'Y') {
                    var notInput = '#userNm, #phoneNo';
                    if (!!$('#zipCode').val()) {
                        notInput += ', #zipCode, #userAddress, #detailAddress';
                    }
                    self.$stepInput.find('#userNm, #phoneNo').prop('readonly', false);
                }
                
                self.$stepInput.find('input[type=radio]').prop('checked', false);
                self.$stepInput.find('input[type=text], input[type=number], textarea').not(notInput).val('');
                self.$stepInput.find('#fanEtc').prop('disabled', true);
                self.$stepInput.find('#n').prop('checked', true);
                self.$stepInput.find('[name=buyingdate]').closest('.conts').find('.form-text').remove();
                self.$stepEngineer.find('#engineerNm').val('');
                self.$stepEngineer.find('#engineerCode').val('');
                self.$stepEngineer.find('#centerNm').val('');
                self.$stepEngineer.find('#centerCode').val('');

                validation.reset();
                self.dateList = null;
                self.$dateWrap.calendar('reset');
                self.$timeWrap.timeCalendarNew('reset').hide(); //BTOCSITE-64827 고객지원 > 출장예약 > 모바일 > 날짜/시간 선택 UI 변경               
                self.$cont.find('.ui_all_checkbox').vcCheckboxAllChecker('setAllNoneChecked');
                self.$cont.find('.ui_textcontrol').trigger('textcounter:change', { textLength: 0 });
                self.$fileUpload.hide().find('.ui_imageinput').vcImageMovFileInput('removeAll'); //BTOCSITE-77120 고객지원 > 출장예약 > 소음증상일 때 파일업로드 기능 추가
                // BTOCSITE-22255 [약관] 비회원 출장서비스 신청 시 마케팅정보수신 약관 표출 요청
                self.$allAgree.hide();
                self.$marketingAgree.hide();

                self.autoFlag = false;
                self.hirun = false;


                self.$cont.find('.inst-move-info').hide(); //이전설치 안내 노출
                self.$modelSelectBox.find('.system-aircon-msg').hide();

                //BTOCSITE-69159 고객지원 > 출장예약 > 에어컨 > 설치장소 추가
                self.bdTypePopup.find('input[name=_bdType]').prop('checked', false);
                $('#purpose').val("");
                $('#selectAcptNo').val(""); //BTOCSITE-82900 고객지원 > 메인 리뉴얼 > 서비스 재접수

            });

            // 모델 선택 후 이벤트
            self.$cont.on('complete', function(e, data) {    

                if(!isLogin) return; //BTOCSITE-62364 모델번호, 제조번호 입력

                var param = data;
                self.checkHirunTimeFlag();
                if (self.hirun) {
                    if(isLogin) {
                        self.$marketingUseAgree.show();
                    }
                    self.$cont.vcSearchModelNew('reset');
                    self.$myModelWrap.show();
                    $('.prod-model-box .btn-prod-next').prop('disabled', true);
                    return;
                }

                self.setBdTypeParam(); //BTOCSITE-69159 고객지원 > 출장예약 > 에어컨 > 설치장소 추가
                self.cleaningBanner(); // BTOCSITE-65147 고객지원 > 출장예약 > 세척서비스 추가
                self.setInstMoveInfo(param); //이전/설치안내 노출
                self.checkSalesInfo(); //폭염특보 안내문 반영의 건

                // BTOCSITE-22255 [약관] 비회원 출장서비스 신청 시 마케팅정보수신 약관 표출 요청
                // BTOCSITE-31948 홈서비스 통합 출장 서비스 주체 변화 (23/3/1 시행)
                // var subCategory = $('#subCategory').val();
                // if ((subCategory == 'CT50019259' || subCategory == 'CT50019244') && !isLogin){
                //     self.$allAgree.show();
                //     self.$marketingAgree.show();
                // }
                self.showMarketingAgree(); // 마케팅동의
                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(self.resultUrl, param, function(result) {
                    var resultData = result.data;
                    self.$cont.vcSearchModelNew('updateSummary', {
                        product: [data.categoryNm, data.subCategoryNm, data.modelCode],
                        isMyProduct: $('#isMyProduct').val(),
                        reset: 'product'
                    });

                    self.setInstallInfo(param); // 에어컨, 세탁기, TV 설치 형태 노출
                    self.setPreInspecInfo(); // BTOCSITE-86673 홈페이지 내 D_10 사전점검 항목 추가


                    self.setTopicList(resultData);

                    if (!!resultData.warrantyText && resultData.warrantValue.toString()) {
                        $('#buyingdate').val(resultData.warrantValue);
                        //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
                        // self.$salesDtWrap.children().eq(1).empty().html(resultData.warrantyText);
                        // self.$salesDtWrap.children().eq(0).hide();
                        // self.$salesDtWrap.children().eq(1).show();

                        // BTOCSITE-47599 로그인 후, 정보 '선택해 주세요' or '입력해 주세요' 부분 문구 정비
                        //$('#saleInfo').find('.tit-wrap .tit').text('1. 제품 구매 정보를 확인해 주세요');
                    } else {
                        $('[name=buyingdate]').closest('.conts').find('.form-text').remove();
                        $('[name=buyingdate]').prop('checked', false);

                        $('[name=buyingdate]').closest('.rdo-list-wrap').show();

                    }
                    
                    // 보유제품 탭 index 체크
                    //var tabIdx = $('#tabs-prod').find('li.on').index();
                    //if(tabIdx.toString() == '0'){
                        self.$prodWrap.hide();
                        self.$myModelWrap.hide(); // 제품 리스트 은폐
                        self.$selectedModelBar.show(); // 플로팅바 노출
                        self.$stepArea.show(); // 정보 입력창 노출
                        self.$productProblemsBox.addClass('open');  //BTOCSITE-44580 보유제품선택시 오픈
                        self.$tabWrap.hide();
                    //}
                        //var target = $('.product-group');
                    //var itemCnt = target.find('ul li').length;

                    //BTOCSITE-80022 고객지원 > 메인 리뉴얼 > 서비스 재접수
                    self.setInstCode();

                    lgkorUI.hideLoading();
                });

            });


            // 모델 선택 후 
            vcui.PubSub.on('completeSummary', function (e, data) {
                var param = data;
                self.param = $.extend(true, self.param, data);

                //BTOCSITE-68698 고객지원 > 출장예약 > 시스템에어컨 > 2인1조 관련 개선사항
                self.checkHirunTimeFlag();
                if (self.hirun) {
                    if(isLogin) {
                        self.$marketingUseAgree.show();
                    }
                    self.$cont.vcSearchModelNew('reset');
                    self.$myModelWrap.show();
                    $('.prod-model-box .btn-prod-next').prop('disabled', true);
                    return;
                }

                self.$selectedModelBar.show();
                self.setInstMoveInfo(param); //이전/설치안내 노출
                self.$productProblemsBox.addClass('open');  // BTOCSITE-44580 유의사항 문구 수정 요청
                
                self.showAirconText(); //BTOCSITE-64551 시스템에어컨 안내 추가

                self.cleaningBanner(); // BTOCSITE-65147 고객지원 > 출장예약 > 세척서비스 추가

                self.setInstallInfo(data); // 에어컨, 세탁기, TV 설치 형태 노출
                self.setPreInspecInfo(); // BTOCSITE-86673 홈페이지 내 D_10 사전점검 항목 추가
                self.checkSalesInfo(); //폭염특보 안내문 반영의 건

                //BTOCSITE-91187 고객지원 > 서비스 예약 > 모델명, 제조번호 입력 시 OCR 제공
                setTimeout(function(){
                    self.validateModelSelectBox();
                }, 200);
            });


            
            self.$tabWrap.on('click', function() {
                var index = self.$tabWrap.vcTab("getSelectIdx");
                if(index.toString() == '0'){
                    self.delModelValue(); //BTOCSITE-62364 모델번호, 제조번호 입력
                }
            });

            // 에어컨 > 업소용,시스템 노출 (이외 비노출)
            self.$cont.find('[name=bdType]').on('change', function() {
                self.showMarketingAgree(); //마케팅동의
                self.checkHirunAndInfo(); // Hirun 2인1조 
                if($('input#subCategory').val() == 'CT50019259'){
                    
                    self.$stepDateBefore.removeClass('open');
                    self.$stepDateBefore.hide();
                    //self.$stepDate.removeClass('active');
                    self.$stepDate.hide();
                    self.$stepEngineer.hide();
                    if (self.autoFlag){
                        self.$stepInput.find('.step-btn-wrap').show();
                        self.$dateBeforeWrap.show();
                    }
                }
                
            });

            //BTOCSITE-62364 모델번호, 제조번호 입력
            $('.prod-model-box').on('click', '.btn-prod-open', function() {
                var $this = $(this);
                var idx = $this.parents('.prod-model-box').index();

                if($this.parents('.prod-model-box').hasClass('open')) return;

                $('.prod-model-box').removeClass('open');
                $('.prod-model-box').eq(idx).addClass('open');
                $('.prod-model-box').find('.system-aircon-msg').hide(); //BTOCSITE-64551 고객지원 > 출장접수 > 시스템에어컨 안내 추가
              
                switch (idx){
                    case 0: //모델명/제조번호 선택
                        $('#categoryNm').val("");
                        $('#subCategoryNm').val("");
                        $('#category').val("");
                        $('#subCategory').val("");

                        self.$modelSelectBox.find('[id="categorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
                        self.$modelSelectBox.find('[id="subCategorySelect"]').children('option:not(:first-child)').remove();
                        self.$modelSelectBox.find('[id="subCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
                        break;
                    case 1: //제품군 선택
					    $('#categoryNm').val("");
						$('#subCategoryNm').val("");
						$('#category').val("");
						$('#subCategory').val("");
						$('#modelCode').val("");
						$('#productCode').val("");
                        $('#salesModelCode').val("");
						$('#serialNumber').val("");

                        self.$modelSearchBox.find('input[type="text"]').val("");
                        self.$modelSearchBox.find('[class^="success-msg"]').hide();
						//BTOCSITE-80487 고객지원 > 출장예약 > 모델명 입력 > 자동완성 미선택
                        self.$modelSearchBox.find('[id="prodCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
                        self.$modelSearchBox.find('[id="prodSubCategorySelect"]').children('option:not(:first-child)').remove();
                        self.$modelSearchBox.find('[id="prodSubCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
                        break;
                }
                    
                $('.prod-model-box').eq(idx).find('.btn-prod-next').prop('disabled', true);
            });

            //BTOCSITE-62364 모델번호, 제조번호 입력
            $('.prod-model-box').on('click', '.btn-prod-next', function() {
                var $this = $(this);
                var idx = $this.parents('.prod-model-box').index();
                switch (idx){
                    case 0: //모델명/제조번호 입력
                        self.$modelSearchBox.find('[class^="success-msg"]').hide();
                        var snVal = self.$modelSearchBox.find('input[name="sn"]').val();
                        $('#serialNumber').val(snVal);
						$('#accessType').val("003"); //모델명/제번 직접입력 구분자추가  

						var modelCode = self.$modelSearchBox.find('input[id="search"]').val().toUpperCase();
						$('#modelCode').val(modelCode);
					
						var param = {
							modelCode: modelCode,
						}
						$.extend(self.param, param);

						self.$cont.vcSearchModelNew('updateSummary', {
						    product: [self.param.categoryNm, self.param.subCategoryNm, self.param.modelCode],
						    reset: 'product'
						});
						
                        break;
                    case 1: //제품군 선택
                    	$('#accessType').val("004"); //제품군선택
                        break;
                }
                //self.$selectedModelBar.show();
                self.$stepArea.show();
                self.$prodWrap.hide();
                //self.$searchArea.hide();
                self.$tabWrap.hide();
                
                self.setBdTypeParam(); //BTOCSITE-69159 고객지원 > 출장예약 > 에어컨 > 설치장소 추가
            });


            // BTOCSITE-62364 모델번호, 제조번호 입력
            self.$modelSearchBox.on('keyup', 'input[name="sn"]', function(e) {
                self.validateModelSelectBox();
        
            });

            self.$modelSearchBox.on('focusout', 'input[id="search"]', function(e) {
				e.preventDefault();
                var searchVal = $(this).val().toUpperCase();
                var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');

                if(chkdata.length > 0){
                    chkdata.trigger('click');

					self.$modelSearchBox.find('[id="prodCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
					self.$modelSearchBox.find('[id="prodSubCategorySelect"]').children('option:not(:first-child)').remove();
					self.$modelSearchBox.find('[id="prodSubCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
                }
            });

            self.$modelSearchBox.on('keyup', 'input[id="search"]', function(e) {
                e.preventDefault();

                var searchVal = $(this).val().toUpperCase();
				var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');

                $(this).val(searchVal);

				var salesModelCode = $('#salesModelCode').val();
				if((e.keyCode === vcui.keyCode.BACKSPACE && salesModelCode != '') || (chkdata.length == 0 && salesModelCode != '')) {
					//모델명 조회 후 백스페이스 삭제
					$('#modelCode').val("");
					$('#productCode').val("");
					$('#salesModelCode').val("");
					$('#category').val("");
					$('#categoryNm').val("");
					$('#subCategory').val("");
					$('#subCategoryNm').val("");
				}

				if (e.keyCode == 13) {  
					if(chkdata.length > 0){
						chkdata.trigger('click');
					}
				}

				self.validateModelSelectBox();
            });

            self.$modelSearchBox.on('click', '.btn-search', function(e) {
                e.preventDefault();
                var searchVal = $('#search').val().toUpperCase();
                var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');

				if(chkdata.length > 0){
					chkdata.trigger('click');
				}
            });

            self.$modelSearchBox.on('click', '.btn-delete', function(e) {
                self.$modelSearchBox.find('input[type="text"]').val('');

                self.delModelValue();
                self.validateModelSelectBox();
            });

            self.$modelSearchBox.on('click', '.search-layer .autocomplete-box a', function(e) {
                $('.keyword-search').removeClass('on');
                setTimeout(function(){
                    self.validateModelSelectBox();
                }, 100);
            });

            //카테고리
            self.$cont.find('#categorySelect').on('change', function(){
                
                self.$modelSelectBox.find('.btn-prod-next').prop('disabled', true); // 버튼 비활성화

                var superCate = $(this).find('option:selected').data('category-name');

                if(superCate == "all") {
                    self.$modelSelectBox.find('#subCategorySelect').find('option:not(:first-child)').remove();
                    self.$modelSelectBox.find('#subCategorySelect').vcSelectbox('update');
                }

                if(superCate !== "all") {

                    //선택된 상품 표시
                    //$('.goods-selected-wrap.prodList').show();
                    // self.$selectedModelBar.find('.product li').eq(0).text(superCate);
                    // self.$selectedModelBar.find('.product li').eq(1).text("");
                }
            });
            //서브 카테고리
            self.$cont.find('#subCategorySelect').on('change', function(){
                var superCate = $(this).find('option:selected').val();
                
                if(superCate !== "all") {
                    //선택된 상품 표시
                    // self.$selectedModelBar.find('.product li').eq(1).text(superCate);
                    // self.$selectedModelBar.fadeIn(500);
                    //$('.topic-notice').hide();
                    //$('.topic-wrap .topics').show();
                    //$(this).closest('.section').hide();
                    
                    self.$modelSelectBox.find('.btn-prod-next').prop('disabled', false);

                }
            });

			//modelSearchBox 카테고리
			self.$modelSearchBox.find('#prodCategorySelect').on('change', function(){
                self.$modelSearchBox.find('.btn-prod-next').prop('disabled', true); // 버튼 비활성화

                var val = $(this).find('option:selected').data('category-name');
                if(val !== "all") {
                    $("#subCategory").val("");
                    $("#subCategoryNm").val("");
                }
			});

			//modelSearchBox 서브 카테고리
			self.$modelSearchBox.find('#prodSubCategorySelect').on('change', function(){
				var $this = $(this);
				var val = $this.find('option:selected').val();
                var nm = $this.find('option:selected').text();
                $("#subCategory").val(val);
                $("#subCategoryNm").val(nm);
				
				if(val !== "all") {
					self.validateModelSelectBox();

				}
			});


            // 증상 선택
            self.$topicList.on('change', '[name=sympCd]', function() {
                self.$sub1TopicBox.hide();
                self.$sub1TopicSelect.empty();
                self.$sub1TopicBox.find('.ui-selectbox-list ul').empty();
                
                self.$sub2TopicBox.hide();
                self.$sub2TopicSelect.empty();
                self.$sub2TopicBox.find('.ui-selectbox-list ul').empty();
                
                self.$fileUpload.hide().find('.ui_imageinput').vcImageMovFileInput('removeAll'); //BTOCSITE-77120 고객지원 > 출장예약 > 소음증상일 때 파일업로드 기능 추가
                
                var currentTopic = this; //BTOCSITE_6554
                
                // 20210610 세척서비스 증상 선택시 팝업 띄움
                var topicName = $(this).data('topicName');
                var subCtg = $('#subCategory').val(); // BTOCSITE-21883 고객지원: 베스트케어 지원  
                
                // BTOCSITE-6144 세척서비스 중지 팝업 다시 원래대로 원복
                // BTOCSITE-13336 고장증상 '세척서비스' 예약 가능하게 기능 수정 요청
                var alertMsg = '가전 <strong class="point">세척 서비스</strong>는 <strong>콜센터 [1544-7777]로</strong><br>전화 주시거나, <strong>전화상담 예약</strong>을 하시면<br>전문 상담사 상담 후 접수를 도와 드리겠습니다.<br><br>전화 상담 예약을 안내해 드릴까요?';                
                if( topicName === "세척서비스" && (subCtg == 'CT50019244' || subCtg == 'CT50019259')){
                    lgkorUI.confirm(alertMsg,{
                        typeClass:'type2',
                        title:'',
                        okBtnName: '네',
                        cancelBtnName: '아니요',
                        ok: function() {
                            location.href = "/support/request-call-reservation";
                        },
                        cancel: function() {
                            $(currentTopic).prop('checked', false); //BTOCSITE_6554
                        }
                    });
                }

                // BTOCSITE-21883 고객지원: 베스트케어 지원   
                var alertMsg2 = '해당 서비스는 LG 베스트 케어 > 가전세척에서 예약하실 수 있습니다. <br><br>가전세척 예약을 안내해 드릴까요?'; 
                // BTOCSITE-46583 정수기 제품 "수질분석 " 접수 증상 추가 대응
                var alertMsg3 = '정수기 <strong class="point">수질 검사</strong> 서비스는 콜센터[1544-7777]로 <br>전화 주시거나, 상담 예약/문의를 하시면, <br>전문 상담사가 상담 후 접수를 도와드겠습니다. <br><br>상담 예약을 안내해 드릴까요?';  
                // BTOCSITE-50304 출장 서비스 예약] 이전설치 예약 안내 팝업 생성
                var alertMsg4 = "제품의 <strong class='point'>이전/재설치/철거</strong> 서비스 예약은 별도 전문 회사에서 진행하고 있습니다. <br><br>※자세한 사항은 'LG 베스트케어 이전설치' 페이지를 참고하여 주세요. <br><br>LG 베스트케어 이전설치로 이동할까요?";  
                var targetSubCtg = vcui.array.include([
                    'CT50019873', 'CT50019275', 'CT50019259', 'CT50109005', 'CT50019244', 'CT50019735', 'CT50019309', 'CT50019709', 'CT50019748', 
                    'CT50019324', 'CT50019722', 'CT50019648', 'CT50019761', 'CT50019680', 'CT50109013', 'CT50109023', 'CT50019483', 'CT50109025',
                    'CT50019037', 'CT50019696', 'CT50109006', 'CT50109003', 'CT50109019', 'CT50172000', 'CT50019229', 'CT50019052', 'CT50019468',
                    'CT50019512', 'CT50019292', 'CT50019442', 'CT50019199', 'CT50109012', 'CT50019184', 'CT50019082', 'CT50109002', 'CT50109011',
                    'CT50019214', 'CT50019455', 'CT50108006', 'CT50111013', 'CT50111012'], subCtg);

                if( topicName === "세척서비스" && (subCtg != 'CT50019244' && subCtg != 'CT50019259')){
                    lgkorUI.confirm('',{
                        typeClass:'type2',
                        title:alertMsg2,
                        okBtnName: '네',
                        cancelBtnName: '아니요',
                        ok: function() {
                            location.href = "/lg-best-care/home-appliance-cleaning/reservation";
                        },
                        cancel: function() {
                            $(currentTopic).prop('checked', false);
                            self.$sub1TopicBox.hide();
                            return;
                        }
                    });
                } else if( topicName.includes('수질') && subCtg == 'CT50019648'){
                    lgkorUI.confirm(alertMsg3,{
                        typeClass:'type2',
                        title:'',
                        okBtnName: '네',
                        cancelBtnName: '아니요',
                        ok: function() {
                            location.href = "/support/request-call-reservation";
                        },
                        cancel: function() {
                            $(currentTopic).prop('checked', false);
                        }
                    });
                } else if( topicName.includes('설치') && targetSubCtg){
                    lgkorUI.confirm(alertMsg4,{
                        typeClass:'type2',
                        title:'',
                        okBtnName: '네',
                        cancelBtnName: '아니요',
                        ok: function() {
                            location.href = "/lg-best-care/service-installation-removal";
                        },
                        cancel: function() {
                            $(currentTopic).prop('checked', false);
                        }
                    });
                } else {
                    var url = self.$topicListWrap.data('ajax'),
                    param = {
                        topic: $(this).val(),
                        serviceType: $('#serviceType').val(),
                        productCode: $('#productCode').val()
                    };
                
                    /* BTOCSITE-3411 add :: 세척 서비스 팝업 얼렛으로 변경 */
                    // var alertMsg = '<p>일시적으로 가전 <strong class="point">세척 서비스</strong> 제공을 중지합니다.<br>서비스 안정화 이후 다시 진행될 예정이오니 양해 바랍니다.</p>';
                    // if( topicName === "세척서비스" ){
                    //     $(this).prop('checked', false);
                    //     lgkorUI.alert(alertMsg);
                    // }
                    /* BTOCSITE-3411 add :: 세척 서비스 팝업 얼렛으로 변경 */
                    self.requestSub1Topic(url, param);
                    self.$sub2TopicSelect.hide();
                    
                    if (self.autoFlag) {
                        self.$solutionsBanner.hide();
                        self.$stepInput.find('.step-btn-wrap').show();
                        self.$dateBeforeWrap.show();
                        //self.$stepDate.removeClass('active');
                        self.$stepEngineer.hide();
                        self.$stepDate.hide();
                        self.$stepDateBefore.hide();
                        self.$dateWrap.calendar('reset');
                        self.$timeWrap.timeCalendarNew('reset').hide(); //BTOCSITE-64827 고객지원 > 출장예약 > 모바일 > 날짜/시간 선택 UI 변경                
                        self.autoFlag = false;
                    }
                    
                    // BTOCSITE-15298 HiRUN 연동 제품, 실외기 2인1조 서비스 필요 건 출장예약 차단
                    self.checkHirunAndInfo();
                }

                self.showStylerDt() //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응

            });

            // 세부1 증상 선택
            self.$sub1TopicSelect.on('change', function() {
                var $this = $(this);

                if($this.find("option:selected").text() === "증상을 선택해 주세요") {
                    return;
                }

                var	url = self.$sub1TopicSelect.data('ajax'),
                    param = {
                        topic: $('input[name=sympCd]:checked').val(),
                        subTopic: $this.val(),
                        productCode: $('#productCode').val(),
                        serviceType: $('#serviceType').val()
                    };

                if (self.autoFlag) {
                    self.$solutionsBanner.hide();
                    self.$stepInput.find('.step-btn-wrap').show();
                    self.$dateBeforeWrap.show();
                    self.$stepEngineer.hide();
                    self.$stepDate.hide();
                    self.$stepDateBefore.hide();
                    self.$dateWrap.calendar('reset');
                    self.$timeWrap.timeCalendarNew('reset').hide();
                    self.autoFlag = false;
                }

                self.$sub2TopicBox.hide();
                self.$sub2TopicSelect.empty();
                self.$sub2TopicBox.find('.ui-selectbox-list ul').empty();
                self.requestSub2Topic(url, param);

                //lgkorUI.scrollTo($('#addDesc'));
                $('#userInfo').addClass('open');

                // BTOCSITE-15298 HiRUN 연동 제품, 실외기 2인1조 서비스 필요 건 출장예약 차단
                self.checkHirunAndInfo();

                self.showStylerDt() //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
            });

            // 세부2 증상 선택
            self.$sub2TopicSelect.on('change', function() {
                var $this = $(this);

                if($this.find("option:selected").text() === "세부 증상을 선택해 주세요") {
                    return;
                }
                var	url = self.$sub2TopicSelect.data('ajax'),
                    param = {
                        topic: $('input[name=sympCd]:checked').val(),
                        subTopic: $('#sTopic01Select option:selected').val(),
                        sympCodeThree: $this.val(),
                        productCode: $('#productCode').val(),
                        serviceType: $('#serviceType').val(),
                    };
                    
                    self.requestSolutions(url, param);
                
                // BTOCSITE-15298 HiRUN 연동 제품, 실외기 2인1조 서비스 필요 건 출장예약 차단
                self.checkHirunAndInfo();
                self.$stepInput.find('.step-btn-wrap').show();
                self.$dateBeforeWrap.show();

                self.showStylerDt(); //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
                self.showFileUpload(); //BTOCSITE-77120 고객지원 > 출장예약 > 소음증상일 때 파일업로드 기능 추가
            });

            //BTOCSITE-69159 고객지원 > 출장예약 > 에어컨 > 설치장소 추가
            //건물유형 선택 팝업
            self.bdTypePopup.on('click', '.btn-bdtype-confirm', function(){
                var val = self.bdTypePopup.find('input[name=_bdType]:checked').val();

                if(!!val){
                    $('#purpose').val(val);
                    self.setProductCode();
                    self.setPreInspecInfo(); //BTOCSITE-86673 홈페이지 내 D_10 사전점검 항목 추가

                    self.bdTypePopup.find('.err-msg').hide();
                    self.bdTypePopup.vcModal('hide');
                }else{
                    self.bdTypePopup.find('.err-msg').show();
                }
            });
            self.bdTypePopup.on('click', '.btn-bdtype-cancel', '.btn-close', function(){
                self.$selectedModelBar.find('.btn-reset').trigger('click');
                self.bdTypePopup.find('input[name=_bdType]').prop('checked', false);
                self.bdTypePopup.find('.err-msg').hide();
                self.bdTypePopup.vcModal('hide');
            });

            // 출장 접수 계속하기
            self.$solutionsBanner.find('.btn-link').on('click', function(){
                self.$solutionsBanner.hide();
                lgkorUI.scrollTo($('#userInfo'));
                // var param = {
                // 	topic : $('input[name=sympCd]:checked').val(),
                // 	subToic : $('input[name=subTopic]:checked').val(),
                // 	productCode : $('#productCode').val(),
                // 	page: 1
                // };   
                // lgkorUI.setAcecounter('www.lge.co.kr/acecount/engineerSolutionsClick.do', '/acecount/engineerSolutionsClickm.do');
                // self.setSolutions(param, false);
            });

            self.$solutionsBanner.find('.btn-chatbot').on('click', function(){
                var subTopic =  $('#sTopic02Select option:selected').text();
                var speech = $('#subCategoryNm').val() + ' ' + subTopic;
                var chatUrl = lgkorUI.getChatDomain() + "/kr/index.html?service=cs&speech=" + encodeURIComponent(speech);
                //var chatUrl = "https://chat.lge.co.kr/?service=cs&speech=" + encodeURIComponent(speech);
                //var chatUrl = "https://chat-qa.lgechat.co.kr/?service=cs&speech=" + encodeURIComponent(speech);
                
                lgkorUI.getChatPinCodeAsUrl(chatUrl, 450, 760);
            });

            // 주소 찾기
            self.$stepInput.find('.btn-address-modal').on('click', function() {
                addressFinder.modal(function(data) { 
                    var address = data.userSelectedType == 'R' ? data.roadAddress : data.jibunAddress;
                    
                    self.$cont.find('#zipCode').val(data.zonecode);
                    self.$cont.find('#userAddress').val(address);
                    self.$cont.find('#detailAddress').val('').prop('readonly', false);
                    self.$cont.find('#detailAddress').focusin();

                    if (self.autoFlag) {
                        self.$stepInput.find('.step-btn-wrap').show();
                        self.$stepDate.hide();
                        //self.$stepDate.removeClass('active');
                        self.$stepEngineer.hide();
                        self.$stepDateBefore.hide();
                        self.$dateBeforeWrap.show();
                        self.$dateWrap.calendar('reset');
                        self.$timeWrap.timeCalendarNew('reset').hide(); //BTOCSITE-64827 고객지원 > 출장예약 > 모바일 > 날짜/시간 선택 UI 변경
                        self.autoFlag = false;
                    }
                });
            });
            
            $('#detailAddress').on('focusout blur', function(){
                if ($(this).val()){
                    lgkorUI.scrollTo($('#agreeToTerms'));
                }
            });

            // 렌탈 체크
            $("input[name='rental']").on('change', function(){
                var data = $("input[name='rental']:checked").val();
                $('#rental').val(data);		
                self.checkSalesInfo();
            });

            // 구입시기 체크
            $('#salesDt').on('change', '[name=buyingdate]', function(){
                var data = $("input[name='buyingdate']:checked").val();
                $('#buyingdate').val(data);		
                self.checkSalesInfo();	
            });

            //의류관리기 구매정보
            //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
            $('input[name=stylerDt]').on('change', function(){
                var data = $(this).val();

                if(data == 0) {
                    var alertMsg = "제품을 구매한 지 아직 한 달이 안 되셨네요. <br>새 제품은 상담사가 증상을 상세히 확인하여 접수를 도와드리고 있습니다. <br>LG전자 고객센터(1544-7777)로 연락해주시기 바랍니다.";

                    lgkorUI.alert('', {
                        title: alertMsg,
                        okBtnName: '확인',
                        ok: function(){
                            $('input[name=stylerDt]').prop('checked', false); //구매정보 리셋
                        },
                        
                    });  
                }
            });

            //BTOCSITE-84932 (WAF 이슈 대응) 고객문의글에 개인정보 Pattern 인식 시, Alert 적용
            self.$textarea.on('focusout', function(){
                var numbers = $(this).val().replace(/[^0-9]/g, "");
                if(numbers.length >= 11){
                    lgkorUI.confirm('', {
                        typeClass: 'type2',
                        title: '<p>혹시 전달사항에 개인 정보(전화번호, 주소 등)가 포함되어 있나요?<br>한 번 더 체크해 주세요.</p>',
                        okBtnName: '개인 정보 없음',
                        cancelBtnName: '수정하기',
                        ok:function(){
                            setTimeout(function(){
                                lgkorUI.scrollTo(self.$userInfoBox);
                                self.$userInfoBox.focus();
                            }, 100);
                        },
                        cancel:function(){ 
                            setTimeout(function(){
                                numbers = '';
                                self.$textarea.focus();
                            }, 500);
                        },
                    });
                }

            });

            // 각 추가정보 체크
            $("input[name='tvPosition'], input[name='fan'], input[name='addFan'], input[name='installType']").on('change', function(){
                self.checkSalesInfo();	
            });

            self.$modifyBtn.on('click', function() {
                self.$stepDateBefore.hide();
                //self.$stepDate.addClass('active');
                self.$stepDate.show();
                self.$scheduleBtnWrap.hide();
            })

            // 예약 가능일자 조회 버튼 클릭
            //self.$dateBeforeWrap.find('.btn-datebefore').on('mousedown', function(e) {
            self.$dateBeforeWrap.on('mousedown', function(e) {
                e.preventDefault();
            }).on('click', function() {
                self.autoFlag = true;
                self.requestFastDate();
            });

            // 일정 수정 버튼 클릭
            self.$modifyBtn.on('mousedown', function(e) {
                e.preventDefault();
            }).on('click', function() {
                self.$stepDateBefore.hide();
                //self.$stepDate.addClass('active');
                self.$stepDate.show();
                self.$scheduleBtnWrap.hide();
                self.autoFlag = true;
                self.requestDate();
            });

            // 날짜 선택
            self.$dateWrap.off('dateselected').on('dateselected', function() {
                var choice = $(this).find('.choice');
                var selectedDate = choice.data('year') + choice.data('month').toString().padStart(2, '0') + choice.data('day').toString().padStart(2, '0');

                //BTOCSITE-72562 출장접수 T/T 제공 로직 보완 진행 (일반, 우선건, 계절성)
                var _deptCode = self.dateList.find(function(item, idx){
                    return item.includes(selectedDate);
                });
                _deptCode = _deptCode.split('/')[1];
                if(!!_deptCode){self.$stepArea.find('#deptCode').val(_deptCode)}

                self.requestTime(selectedDate);
            });

            // 시간 선택
            self.$timeWrap.off('timeselected').on('timeselected', function() {
                var url = self.$stepDate.data('ajax'),
                    param = validation.getAllValues();

                // BTOCSITE-3200 출장서비스 예약 > 추가정보_건물유형 수정 등 
                var productCode = self.getbdTypeParam();

                // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등
                // var purposeCode = $('#purpose').val();

                param = $.extend(param, {
                    sympCd: $('input[name=sympCd]:checked').val(),
                    sympSubCode: $('#sTopic01Select option:selected').val(),
                    sympCodeThree: $('#sTopic02Select option:selected').val(),
                    serviceType: $('#serviceType').val(),

                    productCode: productCode,
                    modelCode: $('#modelCode').val(),
                    // purpose: purposeCode, // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등

                    zipCode: self.$cont.find('#zipCode').val(),
                    userAddress: self.$cont.find('#userAddress').val(),
                    detailAddress: self.$cont.find('#detailAddress').val(),
                    
                    category: $('#category').val(),
                    categoryNm: $('#categoryNm').val(),
                    subCategory: $('#subCategory').val(),
                    subCategoryNm: $('#subCategoryNm').val(),
                    
                    deptCode: self.$stepArea.find('#deptCode').val(),
                    date: self.$stepDate.find('#date').val(),
                    time: self.$stepDate.find('#time').val()
                });

                //BTOCSITE-9289 : 시간까지 선택된 상태에서 페이지 나갈때 param보내는 기능 추가
                var unlockUrl = self.$stepDate.data('unlockUrl'); //데이터 가져오기
                var unlockParam = {}; //unlockParam 빈 객체를 만들기

                if( $('#productCode').val() != undefined) { //빈값이진 undefined인지 확인 : undefined 가 아니면 unlockParam.productCode 는 밸류값이 들어간다
                    unlockParam.productCode = $('#productCode').val()
                }
                if( $('#serviceType').val() != undefined) {
                    unlockParam.serviceType = $('#serviceType').val()
                }
                if( $('#lockUserId').val() != undefined) {
                    unlockParam.lockUserId = $('#lockUserId').val()
                }

                //BTOCSITE-74074  서비스 예약 조회 시 전화번호 값을 응답 못 받는 상황에서의 보완
                //requestSelectDefaultEngineer 에서 hideLoading
                // lgkorUI.requestAjaxDataPost(unlockUrl, unlockParam, function(res){
                //     if (res.data.resultFlag == 'Y') {
                //         //console.log('최초 unlockParam', unlockParam);
                //     }
                // })

                $.ajax({
                    type: "POST",
                    async: true,
                    url: unlockUrl,
                    data: unlockParam,
                    dataType: "json" , 
                    success: function(res){
                        if (res.data.resultFlag == 'Y') {
                            //console.log('최초 unlockParam', unlockParam);
                        }
                    },
                });

                // ////console.log('페이지 나갈때 unlockParam', unlockParam);
                $(window).on("beforeunload", function() {
                    lgkorUI.requestAjaxDataPost(unlockUrl, unlockParam, function(res){
                        if (res.data.resultFlag == 'Y') {
                            //console.log('페이지 나갈때 unlockParam', unlockParam);
                        }
                    })
                });

                ////console.log("2번째 url 가져오기:", unlockUrl);
                
                fastDateYn = "N";

                //BTOCSITE-77120 고객지원 > 출장예약 > 소음증상일 때 파일업로드 기능 추가
                var files = self.$cont.find('.ui_imageinput').vcImageMovFileInput('getSelectFiles');
                if(!$.isEmptyObject(files)){
                    Object.keys(param).forEach(function(key) {
                        if(key.includes('imageFile')) {
                            delete param[key];
                        }
                    });
                }
                self.requestSelectDefaultEngineer(param);
                //self.setPageLeaveEvents();
            });

            // 엔지니어 선택 팝업 오픈
            self.$engineerOpener.on('click', function() {
                var $this = $(this);
                var url = self.$engineerPopup.data('engineerListUrl'),
                    param;

                // var productCode = $('#productCode').val();
                // BTOCSITE-3200 출장서비스 예약 > 추가정보_건물유형 수정 등 
                var productCode = self.getbdTypeParam();

                // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등
                // var purposeCode = $('#purpose').val();

                param = {
                    sympCd: $('input[name=sympCd]:checked').val(), // BTOCSITE-13336 출장 서비스 예약 > 고장증상 '세척서비스' 예약 가능하게 기능 수정 요청
                    sympSubCode: $('input[name=subTopic]:checked').val(), // BTOCSITE-13336 출장 서비스 예약 > 고장증상 '세척서비스' 예약 가능하게 기능 수정 요청
                    sympCodeThree: $('#serviceType').val(),
                    category: $('#category').val(),
                    subCategory: $('#subCategory').val(),
                    lockUserId: $('#lockUserId').val(),
                    zipCode: $('#zipCode').val(),
                    userAddress: $('#userAddress').val(),
                    detailAddress: $('#detailAddress').val(),
                    productCode: productCode,
                    // purpose: purposeCode, // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등
                    date: self.$stepDate.find('#date').val(),
                    time: self.$stepDate.find('#time').val()
                }

                param = $.extend(param, self.dateParam);
                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(url, param, function(result) {
                    var data = result.data,
                        arr = data.engineerList instanceof Array ? data.engineerList : []; 

                    if (data.resultFlag == 'Y') {  
                        if (arr.length) {
                            var html = vcui.template(engineerTmpl, data);

                            /* BTOCSITE-BTOCSITE-7660 고객지원 - 출장/내방/예약변경 시 SE 사진 비노출 요청 */
                            // self.$engineerSlider.find('.slide-track').html(html); // 원본
                            self.$engineerSlider.find('.engineer-infoP').html(html);
                            /* //BTOCSITE-BTOCSITE-7660 고객지원 - 출장/내방/예약변경 시 SE 사진 비노출 요청 */

                            self.$engineerSlider.vcCarousel('reinit');
                        } else {
                            lgkorUI.alert('', {
                                title: '방문 가능한 다른 서비스매니저가 없습니다.'
                            }, $this[0]);
                        }
                    } else {
                        if (data.resultMessage) {
                            lgkorUI.alert("", {
                                title: data.resultMessage
                            }, $this[0]);
                        }
                    }

                    lgkorUI.hideLoading();
                });
            });

            self.$engineerSlider.on('carouselreinit', function() {
                self.$engineerPopup.vcModal();
            });

            self.$engineerPopup.on('modalhidden', function() {
                self.$engineerOpener.focus();
            });

            // 신청 완료
            self.$completeBtn.on('click', function() {
                var result = validation.validate();
                
                if (result.success == true) {    
                    if (isLogin) {
                        lgkorUI.confirm('', {
                            title:'예약 하시겠습니까?',
                            okBtnName: '확인',
                            cancelBtnName: '취소',
                            ok: function() {
                                self.clearPageLeventEvents() //BTOCSITE-9289 : 페이지 나갈때 param보내는 기능 끄기
                                self.requestComplete();
                            }
                        }, this);       
                    } else {
                        authManager.open(function() {
                            $('#authName').val($('#userNm').val()).prop('readonly', true);
                            $('#authPhoneNo').val($('#phoneNo').val()).prop('readonly', true);  
                        });
                    }
                }
            });
            // 신청 완료2
            $('.btn-confirm').on('click', function() {
                var result = validation.validate();
                
                if (result.success == true) {    
                    if (isLogin) {
                        lgkorUI.confirm('', {
                            title:'예약 하시겠습니까?',
                            okBtnName: '확인',
                            cancelBtnName: '취소',
                            ok: function() {
                                self.clearPageLeventEvents() //BTOCSITE-9289 : 페이지 나갈때 param보내는 기능 끄기
                                self.requestComplete();
                            }
                        }, this);       
                    } else {
                        authManager.open(function() {
                            $('#authName').val($('#userNm').val()).prop('readonly', true);
                            $('#authPhoneNo').val($('#phoneNo').val()).prop('readonly', true);  
                        });
                    }
                }
            })

            self.$authPopup.find('.btn-send').on('click', function() {
                authManager.send(this);
            });

            self.$authPopup.find('.btn-auth').on('click', function() {
                authManager.confirm(this, function(success, result) {
                    success && self.requestComplete();
                });
            });

            // 추가정보 - 실외기 위치
            $('[name=fan]').on('change', function() {
                if ($(this).attr('id') == 'fan09') {
                    $('#fanEtc').prop('disabled', false);
                } else {
                    $('#fanEtc').prop('disabled', true);
                    $('#fanEtc').val('');
                }

                // BTOCSITE-15644 출장 서비스 에어컨 제품 실외기 위치 질의 변경 건
                if ($(this).attr('id') == 'fan01' || $(this).attr('id') == 'fan02' || $(this).attr('id') == 'fan03') {
                    self.$addFanBox.show();
                }

                $('input[name=addFan]').prop('checked', false);// 추가정보
                // BTOCSITE-15298 HiRUN 연동 제품, 실외기 2인1조 서비스 필요 건 출장예약 차단
                self.checkHirunAndInfo();
            });


            // 추가정보 - 실외기 위치
            $('[name=addFan]').on('change', function() {
                // BTOCSITE-15298 HiRUN 연동 제품, 실외기 2인1조 서비스 필요 건 출장예약 차단
                self.checkHirunAndInfo();
            });

            $('[name=tvPosition]').on('change', function() {
                if ($(this).attr('id') == 'tvPosition04') {
                    $('#tvPositionEtc').prop('disabled', false);
                } else {
                    $('#tvPositionEtc').prop('disabled', true);
                    $('#tvPositionEtc').val('');
                }
            });

            //BTOCSITE-9289 : 예약 중일때 취소시 param 보내는 여부
            $('#canclePopup .btn-cancel-confirm').on('click', function(e){
                //e.preventDefault();
                self.clearPageLeventEvents();

                var unlockUrl = $('#canclePopup').data('unlockUrl'); //데이터 가져오기
                var _href = $(this).attr('href');
                var unlockParam = {}; //unlockParam 빈 객체를 만들기
                
                if( $('#productCode').val() != undefined) { //빈값이진 undefined인지 확인 : undefined 가 아니면 unlockParam.productCode 는 밸류값이 들어간다
                    unlockParam.productCode = $('#productCode').val()
                }
                if( $('#serviceType').val() != undefined) {
                    unlockParam.serviceType = $('#serviceType').val()
                }
                if( $('#lockUserId').val() != undefined) {
                    unlockParam.lockUserId = $('#lockUserId').val()
                }

                //보내는 param 확인
                //console.log('취소했을때 unlockParam', unlockParam)

                //데이터 통신
                lgkorUI.requestAjaxDataPost(unlockUrl, unlockParam, function(res){
                    if (res.data.resultFlag == 'Y') {
                        location.href = _href; 
                    } else {
                        location.href = _href; 
                    }
                })
            });

            // BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
            var $imgView = $('.btn-img-view');
            $('#select2').on('change', function(){
    
                // 이미지가 없는 경우 no-img 삭제
                if(!(lgkorUI.NO_IMAGE_MODEL_NAME != $imgView.find('img').attr('src'))) {
                    $imgView.find('img').removeClass('no-img');
                }
            });

            // BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
            $imgView.on('click', function(e) {
                e.preventDefault();
            
                if($(this).find('img').hasClass('no-img')) return;
    
                var domain=location.origin;
                var agent = navigator.userAgent;
                var imgUrl=domain + $(this).attr('href');
                var imgAlt = $(this).find('img').attr('alt');
                if(!vcui.detect.isMobileDevice){
                    window.open(imgUrl, '', '');
                    return
                }

                var currOption = $('#select2 option:selected');
                var popTitle = currOption.hasClass('placeholder') ? '모델명 확인 방법' : currOption.text();
                var $zoomPopup = $('#imgZoomPopup');
                var $zoomImg = $('#imgZoomPopup img');
                $zoomImg.attr('src', imgUrl);
                $zoomImg.attr('alt', imgAlt);

                $zoomPopup.find('.tit').html('<span>'+popTitle+'</span>');
                $zoomPopup.vcModal('open');
            });
            
            // 요금 및 보증 기간 안내
            self.warrantyGuide.on('modalhide', function(){
                var $this = $(this);
                var $tab = $this.find('.ui_tab');
                
                // BTOCSITE-13599 요금 및 보증기간 안내 팝업 수정
                $tab.vcTab("select", 0);
            });

            // BTOCSITE-29994 출장서비스 - 희망 일시 선택 후, 고객이 원하는 약속 일자 선택 가능 여부 데이터를 집계
            // BTOCSITE-31616 파일럿 종료) 출장서비스 - 희망 일시 선택 후, 고객이 원하는 약속 일자 선택 가능 여부 데이터를 집계
            // $('[name=desiredServeyYn]').on('change', function() {
            //     var textForm = self.$desiredServey.find('.text-form');
            //     $(this).val() == 'N' ?  textForm.show() : textForm.hide();
            // });
            //모델입력 앤터 처리
            //BTOCSITE-62364 모델번호, 제조번호 입력
            // self.$modelSearchBox.on('keyup', 'input[id=search]', function(e) {

            //     //영문이나 숫자로 이루어진 모델명을 2자 이상 입력해 주세요.
            //     self.$modelSearchBox.find('.search-error').html('영문이나 숫자로 이루어진 모델명을 2자 이상 입력해 주세요.');
            //     self.$modelSearchBox.find('.search-error').hide();
            //     if (e.keyCode == 13) {  
            //         e.preventDefault();
            //         var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('a').attr('data-model-code');
            //         if($('#search').val().toUpperCase() == chkdata){
            //             self.$modelSearchBox.find('.keyword-list').find('li').find('a').trigger('click');                    
            //         }else{
            //             self.$modelSearchBox.find('.search-error').html('"'+$('#search').val().toUpperCase()+'"에 대한 검색 결과가 없습니다.')
            //             self.$modelSearchBox.find('.search-error').show();
            //         }
            //     }
            // });
            // self.$modelSearchBox.find('.btn-search').on('click', function(e){
            //     //console.log('#model-box btn-search click');
            //     e.preventDefault();
            //     var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('a').attr('data-model-code');
            //     if($('#search').val().toUpperCase() == chkdata){
            //         self.$modelSearchBox.find('.keyword-list').find('li').find('a').trigger('click');                    
            //     }else{
            //         self.$modelSearchBox.find('.search-error').html('"'+$('#search').val().toUpperCase()+'"에 대한 검색 결과가 없습니다.')
            //         self.$modelSearchBox.find('.search-error').show();
            //     }
            // });
            //BTOCSITE-64829 고객지원 > 출장예약 > 스스로 해결 콘텐츠 제공
            self.$solutionsBanner.on('click', '.qna-list button', function(e){
                var itemId = $(this).data("itemId");
                var itemTitle =  $(this).html();

                self.$solutionsPopup.find('.qna-cont').hide();
                self.$solutionsPopup.find('.qna-cont[data-item-id=' + itemId + ']').show();
                self.$solutionsPopup.find('.pop-header .tit span').empty().html(itemTitle);
                self.$solutionsPopup.vcModal();
            });
        }
    }

    $(window).ready(function() {	

        reservation.init();
    });
})();